import investmentProposal from "./investmentProposalPages.js";

export default {
  investmentProposal,
  admin: {
    disclaimer: "Disclaimer",
    enterText: "Inserisci un testo",
    holdingDataAdjustments: {
      categorise: {
        allProducts: "Tutti i prodotti",
        allProperties: "Tutte le proprietà",
        applyFilters: "Applica filtri",
        autoFilledValue:
          "Nessuna categoria assegnata; questo campo è stato compilato automaticamente con il valore base.",
        description:
          "Usa questa pagina per assegnare categorie standardizzate ai valori delle proprietà tra i prodotti con dati sulle posizioni.",
        filteredProducts: "Prodotti selezionati",
        filteredProperties: "Proprietà selezionate",
        filterMissingCategories: "Mostra solo non categorizzati: ",
        filterMissingCategoriesTooltip: "Mostra solo le righe senza una categoria assegnata.",
        filterUnsavedModifications: "Mostra solo non salvati: ",
        filterUnsavedModificationsTooltip: "Mostra solo le righe con una modifica non salvata.",
        removeCategory: "Rimuovi questa categoria",
        title: "Categorizza dati posizioni",
        unsavedChangesAlert: "Hai modifiche non salvate. Se esci senza salvare, andranno perse.",
        columns: {
          category: "Categoria",
          productName: "Nome prodotto",
          property: "Proprietà",
          value: "Valore",
        },
        productsMultiselect: {
          placeholder: "Seleziona prodotti da includere",
          selectLabel: "Premi invio per selezionare",
          deselectLabel: "Premi invio per rimuovere",
          selectedLabel: "Selezionato",
          limitText: (ctx) => `e altri ${ctx.named("count")}`,
        },
        propertiesMultiselect: {
          placeholder: "Seleziona proprietà da includere",
          selectLabel: "Premi invio per selezionare",
          deselectLabel: "Premi invio per rimuovere",
          selectedLabel: "Selezionato",
          limitText: (ctx) => `e altre ${ctx.named("count")}`,
        },
      },
      translate: {
        allProducts: "Tutti i prodotti",
        allProperties: "Tutte le proprietà",
        applyFilters: "Applica filtri",
        autoFilledValue:
          "Nessuna traduzione assegnata; questo campo è stato compilato automaticamente con la categoria base.",
        description:
          "Usa questa pagina per assegnare traduzioni ai valori delle categorie tra i prodotti e le proprietà con dati sulle posizioni.",
        filteredProducts: "Prodotti selezionati",
        filteredProperties: "Proprietà selezionate",
        filterMissingTranslations: "Mostra solo non tradotti: ",
        filterMissingTranslationsTooltip: "Mostra solo le righe con una traduzione non assegnata.",
        filterUnsavedModifications: "Mostra solo non salvati: ",
        filterUnsavedModificationsTooltip: "Mostra solo le righe con una modifica non salvata.",
        langNotAvailable: "Questa lingua non è disponibile per questo prodotto.",
        title: "Traduci categorizzazione dati posizioni",
        unsavedChangesAlert: "Hai modifiche non salvate. Se esci senza salvare, andranno perse.",
        columns: {
          category: "Categoria",
          productName: "Nome prodotto",
          property: "Proprietà",
        },
        productsMultiselect: {
          placeholder: "Seleziona prodotti da includere",
          selectLabel: "Premi invio per selezionare",
          deselectLabel: "Premi invio per rimuovere",
          selectedLabel: "Selezionato",
          limitText: (ctx) => `e altri ${ctx.named("count")}`,
        },
        propertiesMultiselect: {
          placeholder: "Seleziona proprietà da includere",
          selectLabel: "Premi invio per selezionare",
          deselectLabel: "Premi invio per rimuovere",
          selectedLabel: "Selezionato",
          limitText: (ctx) => `e altre ${ctx.named("count")}`,
        },
      },
      override: {
        allProducts: "Tutti i prodotti",
        applyFilters: "Applica filtri",
        filteredProducts: "Prodotti selezionati",
        propertyNotAvailable: "La proprietà non è disponibile per il prodotto.",
        filterPresentOverrides: "Mostra solo sovrascritti: ",
        filterPresentOverridesTooltip: "Mostra solo le righe con un valore sovrascritto.",
        filterUnsavedModifications: "Mostra solo non salvati: ",
        filterUnsavedModificationsTooltip: "Mostra solo le righe con una modifica non salvata.",
        overriddenTooltip: (ctx) => `Sovrascrive: ${ctx.named("value")}`,
        textUniqueKeys:
          "Questa tabella mostra i valori base dei dati delle posizioni per tutti i prodotti disponibili sulla piattaforma. Ogni voce unica è identificata da una combinazione di 'Nome prodotto', 'Nome posizione', 'Valuta' e 'ISIN'.",
        textHowToSingleOverride:
          "Per visualizzare o modificare le sovrascritture per una riga, cliccaci sopra per espandere i dettagli. I valori sovrascritti che differiscono dai valori base saranno evidenziati: il testo giallo indica le sovrascritture e il testo in corsivo evidenzia le sovrascritture non salvate.",
        textHowToBulkOverride:
          "Se desideri applicare aggiornamenti in massa, si consiglia di scaricare le attuali sovrascritture dei dati delle posizioni come file CSV grazie al pulsante di esportazione. Puoi quindi apportare modifiche utilizzando uno strumento di foglio di calcolo (es. Microsoft Excel) e ricaricare il CSV modificato su questa pagina.",
        title: "Sovrascrivi dati posizioni",
        unsavedChangesAlert: "Hai modifiche non salvate. Se esci senza salvare, andranno perse.",
        columns: {
          productName: "Nome prodotto",
        },
        productsMultiselect: {
          placeholder: "Seleziona prodotti da includere",
          selectLabel: "Premi invio per selezionare",
          deselectLabel: "Premi invio per rimuovere",
          selectedLabel: "Selezionato",
          limitText: (ctx) => `e altri ${ctx.named("count")}`,
        },
      },
    },
    operations: {
      bulkPriceDataUpdate: {
        benchmarks: "Benchmark",
        benchmarkName: "Nome benchmark",
        products: "Prodotti",
        productName: "Nome prodotto",
        metaInfo: {
          title: "Admin - Operazioni - Aggiornamento massivo prezzi",
        },
        dashboard: {
          createdAt: "Creato alle",
          createdBy: "Creato da",
          downloadFile: "Scarica file",
          fileDownloadError: "Errore durante il download del documento, contattaci.",
          loadingOperations: "Caricamento operazioni...",
          newUpdate: "Nuovo aggiornamento...",
          refreshButton: "Aggiorna",
          status: "Stato",
          uploadedFile: "File caricato",
        },
        dryRunError: {
          backToUploadCsvButton: "Torna al caricamento CSV",
          csvParsingErrorTitle: "Errore analisi CSV",
          csvParsingErrorText:
            "Il file fornito non è un file CSV valido o non ha il formato corretto. Assicurati che tutte le righe abbiano valori, che le colonne siano ordinate correttamente e che non ci siano valori mancanti.",
          nanFoundTitle: "Trovati valori vuoti",
          nanFoundText:
            "Sono stati trovati alcuni valori vuoti, assicurati che tutte le righe e colonne contengano un valore.",
          numberFormatErrorTitle: "Errore formato numero",
          numberFormatErrorText:
            "I numeri nel tuo file non hanno potuto essere analizzati. Assicurati che i numeri seguano il formato corretto: usa solo caratteri numerici standard e usa un punto (.) per i decimali. Evita altri caratteri speciali.",
          duplicateDateErrorTitle: "Errore data duplicata",
          duplicateDateErrorText: `I seguenti ID contengono date duplicate. Ogni ID dovrebbe avere date uniche per ogni voce.`,
          unknownIdsTitle: "ID sconosciuti",
          unknownIdsText: `I seguenti ID non sono riconosciuti. Assicurati che vengano utilizzati solo ID validi dalle tabelle in questa pagina.`,
          unauthorizedTitle: "ID non autorizzati",
          unauthorizedText: `I seguenti ID non sono autorizzati per gli aggiornamenti.`,
        },
        preparationAndDryRun: {
          backToDashboardButton: "Torna alla Dashboard",
          idToUseInCsv: "ID da usare nel CSV",
          uploadCsvForPreview: "Carica CSV per anteprima...",
          title: "Carica CSV per anteprima dati",
          csvUploadDialog: {
            acceptText: "Genera anteprima",
            title: "Carica CSV per anteprima",
            text: "Seleziona un file CSV per visualizzare l'anteprima degli aggiornamenti di prezzi e benchmark. Questa simulazione simulerà le modifiche, consentendoti di rivederle nella schermata successiva prima di finalizzare.",
          },
          explanation: {
            el1: 'La colonna ID deve contenere i valori trovati nella colonna "ID da usare nel CSV" nelle tabelle sottostanti.',
            el2: "La colonna DATE deve seguire il formato AAAA-MM-GG (es. 2023-10-15, 1999-01-31).",
            el3: "Il PRICE deve essere un valore decimale.",
            el4: "Il PRICE_ADJ deve essere un valore decimale. Questa colonna rappresenta generalmente prezzi rettificati per dividendi, frazionamenti e altri eventi.",
            para1:
              "Per aggiornare prezzi e benchmark in massa, carica un file CSV con tre o quattro colonne: ID, DATE, PRICE, e facoltativamente PRICE_ADJ. L'ordine deve essere rispettato, così come la presenza delle intestazioni nel CSV. Se la colonna facoltativa non viene fornita, si presume che i prezzi rettificati siano uguali ai prezzi.",
            para2:
              "Tutti i prezzi che sei autorizzato ad aggiornare, siano essi prezzi di un prodotto o di un benchmark, sono visualizzati nella/e tabella/e sottostante/i. Se manca qualcosa che ti aspetti di vedere, contattaci.",
            tip: '<em>Consiglio</em>: Clicca <a href="/sample-bulk-price-data-update.csv" download><u>qui</u></a> per scaricare un file CSV di esempio come riferimento.',
          },
        },
        reviewAndConfirm: {
          backToUploadCsvButton: "Torna al caricamento CSV",
          confirmAndApplyChangesButton: "Conferma e applica modifiche",
          firstDate: "Prima data",
          id: "ID",
          lastDate: "Ultima data",
          name: "Nome",
          numberOfRows: "Numero di righe",
          reviewAndConfirmText:
            "Ecco un riepilogo degli aggiornamenti da applicare. Tieni presente che i prezzi pianificati per l'aggiornamento sostituiranno completamente i prezzi esistenti, poiché i vecchi prezzi verranno eliminati prima dell'inserimento dei nuovi. Una volta riviste le modifiche, conferma in basso.",
          title: "Rivedi e conferma aggiornamenti dati",
          successDialog: {
            title: "Operazione avviata",
            text: "L'operazione è stata avviata con successo!",
          },
        },
      },
      exports: {
        description:
          "Puoi creare esportazioni della Piattaforma per salvare tutti i dati della Piattaforma (prezzi, posizioni, documenti, ecc...) in un unico file ZIP.",
        newExport: "Nuova esportazione",
        refreshButton: "Aggiorna",
        successText: "L'esportazione è stata avviata con successo. Presto potrai scaricarla.",
        table: {
          createdAt: "Creato alle",
          createdBy: "Creato da",
          file: "File",
          fileTooltip: "Scarica file",
          status: "Stato",
        },
      },
      generateReports: {
        allLanguages: "Tutte le lingue",
        allProducts: "Tutti i prodotti",
        createdAt: "Creato alle",
        createdBy: "Creato da",
        reportGenerationFilters: "Filtri generazione report",
        file: "File",
        fileName: "Nome file",
        fileTooltip: "Scarica file",
        fileZipTooltip: "Scarica tutti i report come ZIP",
        finishedAt: "Finito alle",
        generationNotPossibleDate:
          "L'ultima data selezionata è precedente alla data di lancio del prodotto.",
        generationNotPossibleLang: "Questa lingua non è disponibile per il prodotto selezionato.",
        generationNotPossibleReport:
          "Il report selezionato non è disponibile per il prodotto selezionato.",
        generationPossible: "La generazione del report è possibile.",
        generationWarningFileExists:
          "Esiste già un file con questo nome e lingua. Procedere sovrascriverà il file esistente.",
        generateSelectedReports: "Genera report selezionati",
        generationStatus: "Stato generazione",
        backToDashboardButton: "Torna alla dashboard",
        backToFiltersButton: "Torna ai filtri",
        language: "Lingua",
        lastDateToInclude: "Ultima data da includere",
        lastDayOfData: "Ultimo giorno di dati",
        loadingOperations: "Caricamento operazioni...",
        newButton: "Genera nuovi report...",
        noReportsBecauseNoAccessToProducts:
          "Non hai accesso ad alcun prodotto per il quale sono stati generati tali rapporti.",
        preparingReportsGeneration: "Preparazione elenco report per la generazione...",
        product: "Prodotto",
        refreshButton: "Aggiorna",
        requireLogin: "Richiedi accesso",
        saveInDocuments: "Salva nella sezione Documenti",
        disabledBecauseNotSavingInDocuments:
          "Applicabile solo quando si salvano i report nella sezione Documenti.",
        selectReportsForGeneration: "Seleziona report per la generazione",
        selectLanguages: "Seleziona lingue",
        selectProducts: "Seleziona prodotti",
        selectReport: "Seleziona report",
        setAsLastFactsheet: "Imposta come ultimo factsheet per il prodotto",
        showAvailableReport: "Mostra report disponibili",
        status: "Stato",
        zipFile: "File ZIP",
        langMultiselect: {
          placeholder: "Seleziona lingue da includere",
          selectLabel: "Premi invio per selezionare",
          deselectLabel: "Premi invio per rimuovere",
          selectedLabel: "Selezionato",
          limitText: (ctx) => `e altre ${ctx.named("count")}`,
        },
        metaInfo: {
          title: "Admin - Operazioni - Genera Report",
        },
        productsMultiselect: {
          placeholder: "Seleziona prodotti da includere",
          selectLabel: "Premi invio per selezionare",
          deselectLabel: "Premi invio per rimuovere",
          selectedLabel: "Selezionato",
          limitText: (ctx) => `e altri ${ctx.named("count")}`,
        },
        successDialog: {
          title: "Operazione creata",
          text: "L'operazione è stata avviata con successo!",
        },
      },
      bulkComponentUpdate: {
        action: "Azione",
        actionIcons: {
          add: "Aggiungi",
          edit: "Modifica",
          error: "Errore",
        },
        backToDashboardButton: "Torna alla Dashboard",
        bulkUpdate: "Carica CSV e vedi le potenziali modifiche...",
        bulkUpdateShortDesc:
          "Aggiungi o aggiorna componenti generici importando CSV dal tuo dispositivo",
        bulkUpdateDesc: {
          action: "Fornisci il CSV per aggiornare o aggiungere i componenti generici.",
          instructions:
            "Il CSV deve avere 7 colonne corrispondenti in ordine a ID prodotto, ID componente, tipo componente, lingua, chiave, valore e vista.",
          trigger:
            "Dopo aver caricato il file CSV, potrai rivedere i componenti che verranno aggiunti o modificati. Se sei soddisfatto delle modifiche proposte, potrai confermare per finalizzare gli aggiornamenti ai componenti.",
        },
        componentId: "ID componente",
        createdAt: "Creato alle",
        createdBy: "Creato da",
        errorsIntro: "Ecco l'elenco delle regole che il CSV viola:",
        errorListTitle: "Il file CSV fornito contiene errori",
        importing: {
          sucessfulImport: "I componenti sono aggiornati.",
          uknownFailure: "Impossibile importare i componenti.",
        },
        importComponentsButton: "Conferma e applica modifiche",
        key: "Chiave",
        lang: "Lingua",
        loadingOperations: "Caricamento operazioni...",
        loadingPreview: "Caricamento modifiche...",
        metaInfo: {
          title: "Admin - Operazioni - Aggiornamento massivo componenti",
        },
        numComponents: "Numero di componenti",
        numElements: "Numero di elementi",
        view: "Vista",
        previewTitle: "Anteprima delle modifiche che verranno apportate",
        product: "Prodotto",
        rules: {
          allowedLang: "La lingua deve essere esistente per il prodotto corrispondente.",
          columns:
            "Devono esserci 7 colonne nel seguente ordine: ID prodotto, ID componente, tipo componente, lingua, chiave, valore, vista.",
          invalidFile:
            "Impossibile analizzare il file CSV. Assicurati di avere il file CSV corretto.",
          keyDuplication: "Le chiavi non possono essere duplicate.",
          linking: "I componenti collegati non possono essere aggiornati simultaneamente.",
          multipleTypes: "Tipi multipli specificati per lo stesso componente.",
          naValue: "Il CSV fornito non può contenere valori NaN.",
          nonEditableComponent:
            "Un componente non può essere modificato poiché è un componente predefinito o il tipo di componente specificato è errato.",
          nonFloatValue: "La colonna valore nel caso dei grafici deve contenere numeri.",
          numRowsPerLang: "Dovrebbe esserci lo stesso numero di righe per ogni lingua.",
          productExists: "Gli ID prodotto devono essere validi.",
          unsupportedView: "Vista non supportata.",
          unsupportedType:
            "I tipi di componente consentiti sono: 'horizontal-bar-chart', 'vertical-bar-chart', 'pie-chart', 'donut-chart', 'table'.",
        },
        type: "Tipo",
        value: "Valore",
      },
    },
    platformSettings: {
      platformSettings: "Impostazioni piattaforma",
      complianceTab: {
        checksActivated: "Controlli attivati",
        editTitle: "Modifica compliance",
        title: "Compliance",
        investorProfile: {
          disclaimerTooltip:
            "Questo testo verrà mostrato agli utenti che arrivano sulla Piattaforma e a cui viene chiesto il loro profilo investitore (tipo e paese). Assicurati di scrivere un disclaimer appropriato e legale.",
          goToInvestorProfilePage: "Apri pagina",
          seeInvestorProfilePage: "Vedi pagina profilo investitore",
          showLogoOnInvestorProfile: "Mostra logo sulla pagina profilo investitore",
          title: "Profilo investitore",
          tooltip:
            'Puoi attivare i controlli del profilo investitore, il che significa che quando un utente arriva sulla tua Piattaforma per la prima volta, dovrà selezionare il proprio tipo di investitore (al dettaglio, professionale, istituzionale) e il proprio paese. Puoi quindi configurare quale tipo di investitore e da quale paese è autorizzato a vedere ciascun prodotto/classe di quote; questo può essere fatto nella sezione Admin>Prodotti, sotto la scheda "Restrizioni di accesso", una volta attivati i controlli qui.',
        },
        notify: {
          saveSuccessText: "Le impostazioni di compliance sono state aggiornate con successo.",
          saveSuccessTextWithLang: (ctx) =>
            `Le impostazioni di compliance sono state aggiornate con successo (lingua: ${ctx.named("lang")}).`,
        },
        ombudsman: {
          title: "Testo Ombudsman",
          tooltip:
            "Se hai bisogno di avere un riferimento al tuo ombudsman su questa Piattaforma, scrivi il testo che verrà mostrato agli utenti che controllano il tuo ombudsman. Un link a questo testo sarà visibile nel piè di pagina della Piattaforma, accanto alla Politica sulla Privacy.",
        },
        productDisclaimer: {
          title: "Disclaimer prodotto predefinito",
          tooltip:
            'Imposta un disclaimer prodotto predefinito che verrà utilizzato per tutti i prodotti che non hanno un disclaimer specifico. Puoi impostare un disclaimer specifico per il prodotto andando su "Admin > Prodotti", selezionando il prodotto di tua scelta e impostando il disclaimer specifico nella scheda "Generale".',
        },
      },
      rolesTab: {
        editTitle: "Modifica ruoli",
        title: "Ruoli",
        description:
          'Di default, esiste solo il ruolo "admin", un ruolo che dà diritti di amministrazione su tutti i prodotti e accesso alle impostazioni della piattaforma. Può essere utile avere ruoli più granulari, ad esempio dando ad alcuni utenti permessi di gestione o visualizzazione solo per alcuni prodotti. Per creare tali ruoli, usa la tabella seguente. Nota che una volta salvati i ruoli, dovrai andare alla pagina {0} per assegnare i ruoli agli utenti di tua scelta.',
        roleNameValidationError: "Questo nome ruolo è già usato da un altro ruolo.",
        permissions: {
          manage: "Gestisci",
          view: "Visualizza",
        },
        table: {
          roleNameHeader: "Nome ruolo",
          permissionHeader: "Permesso",
          productsHeader: "Prodotti",
          removeRoleTooltip: "Rimuovi ruolo",
          addRoleTooltip: "Aggiungi ruolo",
          productsMultiselect: {
            placeholder: "Seleziona prodotto",
            selectLabel: "Premi invio per selezionare",
            deselectLabel: "Premi invio per rimuovere",
            selectedLabel: "Selezionato",
            limitText: "e altri {count}",
          },
        },
        notify: {
          saveSuccessText: "I ruoli sono stati aggiornati con successo.",
        },
      },
      styleTab: {
        colorScheme: "Schema colori",
        colorSchemePicker: "Selettore schema colori",
        colorSchemeTooltip:
          "Lo schema colori è utilizzato in tutta la piattaforma. Se non vengono forniti colori personalizzati, viene generato al volo un set di sfumature derivate dal colore primario della piattaforma. Questo schema colori è attualmente applicato ai grafici a torta e a ciambella.",
        editTitle: "Modifica",
        title: "Stile",
        notify: {
          saveSuccessText: "Lo stile è stato aggiornato con successo.",
        },
      },
      metaInfo: {
        title: "Admin - Impostazioni Piattaforma",
      },
    },
    products: {
      contactUsToFixError:
        "Contattaci utilizzando il modulo di contatto per correggere questo errore!",
      langTabError: "Alcuni campi non sono validi nella lingua:",
      overwriteDataAllShareClasses: "Sovrascrivi dati di tutte le classi di quote",
      tabError: "Alcuni campi non sono validi",
      unsavedChangesAlert: "Hai modifiche non salvate. Se esci senza salvare, andranno perse.",
      accessRestrictionsTab: {
        allCountries: "Tutti i paesi",
        countriesAllowedForInstitutionalInvestors: "Paesi consentiti per investitori istituzionali",
        countriesAllowedForProfessionalInvestors: "Paesi consentiti per investitori professionali",
        countriesAllowedForRetailInvestors: "Paesi consentiti per investitori al dettaglio",
        editAccessRestrictions: "Modifica restrizioni di accesso",
        title: "Restrizioni di accesso",
        warningEnablingAccessRestrictions:
          'Per poter modificare le restrizioni di accesso, attiva i controlli del profilo investitore nelle {0}, sotto la scheda "Compliance".',
      },
      detailsTab: {
        editDetails: "Modifica dettagli",
        key: "Chiave",
        title: "Dettagli",
        value: "Valore",
      },
      dialog: {
        saveFieldInAllShareClasses: {
          title: "Sovrascrivi",
          text: "Stai per sovrascrivere questo campo in tutte le altre classi di quote di questo prodotto, non solo nella classe corrente. Sei sicuro?",
        },
        saveInAllShareClasses: {
          title: "Sovrascrivi",
          text: (ctx) =>
            `Stai per sovrascrivere i dati "${ctx.named(
              "tabName"
            )}" di tutte le altre classi di quote di questo prodotto con i dati "${ctx.named(
              "tabName"
            )}" di questa classe (non solo le ultime modifiche apportate). Sei sicuro?`,
        },
      },
      followersTab: {
        addedByAdmin: "Aggiunto dall'admin",
        addFollowerButton: "Aggiungi un follower",
        email: "Email",
        exportCsv: "Esporta come CSV",
        importCsv: "Importa da CSV",
        noDataText: "Nessuno segue questo prodotto",
        product: "Prodotto",
        removeFollowerTooltip: "Rimuovi follower per il prodotto corrispondente",
        sendEmail: "Invia un'email",
        showAnyShareClass: "Mostra follower di qualsiasi classe di quote",
        title: "Follower",
        addFollowerPrompt: {
          email: "Email del follower",
          emailAlreadyExists:
            "Qualcuno con questo indirizzo email sta già seguendo questo prodotto.",
          file: "File CSV",
          language: "Lingua del follower",
          text: "Prima di aggiungere manualmente un follower, devi assicurarti che accetti di ricevere qualsiasi informazione tu stia pianificando di inviargli.",
          titleAddFollower: "Aggiungi follower",
          titleImportFollowers: "Importa follower",
        },
        notify: {
          newFollowerAddedSuccess: "Il nuovo follower è stato aggiunto con successo.",
          newFollowerAddedError:
            "Si è verificato un problema durante l'aggiunta del nuovo follower. Riprova o contattaci se il problema persiste.",
          noDataInCsv: "Nessuna email da aggiungere (dopo aver filtrato le email già presenti).",
          noEmailHeader:
            "Al tuo file manca un'intestazione di colonna che rappresenti le email. Le intestazioni di colonna accettate sono le seguenti (case insensitive): email o e-mail.",
          followerRemovedSuccess: "Il follower è stato rimosso con successo.",
          followerRemovedError:
            "Si è verificato un problema durante la rimozione del follower. Riprova o contattaci se il problema persiste.",
          wrongFormatEmails: (ctx) =>
            `Il tuo file contiene email con formato errato: ${ctx.named("emails")}`,
        },
        removeFollowerPrompt: {
          acceptText: "Rimuovi follower",
          text: (ctx) =>
            `Sei sicuro di voler rimuovere "${ctx.named(
              "followerEmail"
            )}" dal seguire il prodotto "${ctx.named("productName")}"?`,
          title: "Rimuovi follower",
        },
      },
      generalTab: {
        editGeneralField: "Modifica campo generale",
        visibility: "Visibilità",
        visibilityProductTooltip:
          "Definisce chi può vedere il prodotto: Pubblico (tutti gli utenti) o Privato (solo Gestori e Visualizzatori).",
        visibilityPublic: "Pubblico",
        visibilityPrivate: "Privato",
        icon: "Icona",
        isin: "ISIN",
        title: "Generale",
      },
      permalinksTab: {
        title: "Permalinks",
        lastFactsheet: {
          title: "Ultima scheda informativa",
          noPermalink:
            "Nessun documento è impostato come ultima scheda informativa per questo prodotto, quindi non è ancora disponibile alcun permalink.",
        },
        specificDocument: {
          title: "Documento specifico",
          noDocuments: "Nessun documento è disponibile per questo prodotto.",
        },
      },
      holdingDataTab: {
        title: "Dati posizioni",
        noHoldingData: "Nessun dato sulle posizioni disponibile per questo prodotto.",
        issuePartialHoldingDataSetup:
          "La configurazione dei dati delle posizioni è incompleta e quindi non disponibile. Contatta il team Alquant se riscontri questo problema.",
        launchHoldingUpdateButton: "Avvia aggiornamento",
        launchHoldingUpdateTooltip:
          "Cliccando su questo pulsante si forza un aggiornamento recuperando i dati più recenti dalla fonte normalmente usata per l'aggiornamento automatico giornaliero. I dati possono richiedere alcuni minuti per essere recuperati e aggiornati.",
        launchHoldingUpdateRunningTooltip:
          "I dati sulle posizioni sono attualmente in fase di recupero.",
        refreshButton: "Aggiorna",
        showMissingManualPropertyData: "Mostra righe con dati manuali mancanti: ",
        showMissingManualPropertyDataTooltip:
          "Attiva per evidenziare i componenti che mancano di valori per qualsiasi proprietà manuale.",
        showTransformedData: "Mostra dati trasformati: ",
        switchRawTransformedDataTooltip:
          "Attiva questo pulsante per visualizzare i dati trasformati. Questa vista applica categorizzazioni, sostituzioni e traduzioni ai dati e alle loro proprietà. Nota: eccetto per la selezione della data e la ricerca, le interazioni sono disponibili solo nella vista non trasformata.",
        columns: {
          value: "Valore",
          weight: "Peso",
        },
        notify: {
          launchSuccessText:
            "L'aggiornamento dei dati sulle posizioni è stato avviato con successo. Aggiorna tra qualche minuto per vedere i risultati.",
          launchErrorText:
            "Errore durante l'avvio dell'aggiornamento dei dati sulle posizioni, contattaci.",
        },
      },
      keyCharacteristicsTab: {
        header: "Intestazione",
        icon: "Icona",
        paragraph: "Paragrafo",
        title: "Caratteristiche chiave",
      },
      metaInfo: {
        title: "Admin - Impostazioni Prodotti",
      },
      notify: {
        productSaveSuccess:
          "La configurazione del prodotto è stata aggiornata con successo. | La configurazione dei prodotti è stata aggiornata con successo.",
      },
      priceDataTab: {
        title: "Dati prezzi",
        noPriceData: "Nessun dato sui prezzi disponibile per questo prodotto.",
        benchmarks: {
          title: "Benchmark",
        },
        product: {
          title: "Prodotto",
        },
      },
      selectCard: {
        loadingProducts: "Caricamento prodotti...",
        loadingShareClasses: "Caricamento classi di quote...",
        noProducts: "Non hai prodotti.",
        selectProduct: "Seleziona un prodotto",
        selectShareClass: "Seleziona una classe di quote",
      },
    },
    users: {
      tabName: "Elenco utenti",
      company: "Azienda",
      country: "Paese",
      email: "Email",
      emailCopied: "L'email è stata copiata.",
      investorType: "Tipo investitore",
      name: "Nome",
      lastVisit: "Ultima visita",
      phone: "Telefono",
      roles: "Ruoli",
      metaInfo: {
        title: "Admin - Elenco Utenti",
      },
    },
  },
  auth: {
    email: "Email",
    errorAlreadyEmailAndPasswordRegister:
      "Sei già registrato con questa email e una password. Accedi con questa email e la tua password.",
    errorInternal: "Si è verificato un errore interno. Contattaci.",
    or: "o",
    password: "Password",
    login: {
      errorAccountNotExist: "Non hai un account su questa piattaforma, crea un account e riprova.",
      errorInvalidLoginCredentials:
        "Le credenziali fornite non corrispondono a nessuno dei nostri account utente. Questa discrepanza potrebbe essere dovuta a un'email o password errata, all'assenza di un account associato all'email inserita o alla possibilità che l'email sia collegata a un metodo di accesso alternativo (come Google). Verifica le tue informazioni e riprova o crea un account se necessario.",
      errorNeedEmailVerification:
        "Devi verificare la tua email prima di provare a connetterti alla nostra piattaforma. Controlla le tue email (e la cartella spam) per trovare l'email. Se non riesci a trovarla, reimposta la password.",
      noAccountYet: "Non hai ancora un account?",
      rememberMe: "Ricordami",
      welcomeBack: "Bentornato, accedi al tuo account.",
      dialog: {
        alreadyLoggedInText: "Hai già effettuato l'accesso!",
      },
      metaInfo: { title: "Piattaforma - Login" },
      notify: {
        newAccessRight: {
          title: "Nuovi diritti di accesso",
          text: "Sei stato disconnesso automaticamente perché ti sono stati assegnati nuovi diritti di accesso che richiedono un nuovo login per essere convalidati.",
        },
        registrationSuccess: {
          title: "Registrazione riuscita",
          text: "Registrazione avvenuta con successo, ti abbiamo inviato un messaggio per convalidare il tuo indirizzo email, controlla la tua casella di posta!",
        },
        requiresRecentLogin: {
          title: "Riautenticazione richiesta",
          text: "Per procedere con questa azione, accedi di nuovo poiché la tua sessione è scaduta. Una volta riautenticato, puoi riprovare l'azione.",
        },
        unexpectedError: {
          title: "Errore imprevisto",
          text: "Si è verificato un errore imprevisto. Accedi di nuovo. Se il problema persiste, contatta il supporto per assistenza.",
        },
      },
    },
    login2fa: {
      enterCode: "Inserisci il codice a 6 cifre dalla tua app di autenticazione.",
      incorrectCode: " Il codice non è corretto. Riprova.",
      title: "Autenticazione a 2 fattori",
      verify: "Verifica",
      verifying: "Verifica in corso...",
    },
    register: {
      alreadyRegistered: "Già registrato?",
      confirmPassword: "Conferma password",
      createAccount: "Crea account",
      errorAlreadyEmailAndPasswordRegister:
        "Hai già un account con questa email. Accedi al tuo account.",
      errorAlreadyGoogleRegister:
        "Sei già registrato con questo account Google. Accedi con questo account.",
      errorAlreadyMicrosoftRegister:
        "Sei già registrato con questo account Microsoft. Accedi con questo account.",
      fillBelowForm:
        'Compila il modulo sottostante per creare un nuovo account. I campi contrassegnati con <span class="text-danger">*</span> sono obbligatori.',
      registerWith: "Registrati con: ",
      form: {
        agreeAdvertisementOnly:
          "Accetto esplicitamente che tutte le informazioni fornite su questa piattaforma siano solo a scopo informativo e pubblicitario e non debbano essere interpretate come un'offerta, una consulenza o una raccomandazione per acquistare o vendere un particolare titolo o per effettuare qualsiasi transazione.",
        certifyAdult: "Certifico di avere almeno 18 anni.",
        company: "Azienda",
        confirmPassword: "Conferma password",
        email: "Email",
        firstName: "Nome",
        investorProfileCountry: "Paese",
        investorProfileType: "Tipo investitore",
        lastName: "Cognome",
        needAgree: "Devi accettare",
        phone: "Telefono",
        privacyPolicy: "politica sulla privacy",
        registeringAccept: "Registrandoti, accetti i nostri {0} e {1}.",
        termsOfUse: "termini di utilizzo",
      },
      dialog: {
        alreadyLoggedInText: "Hai già effettuato l'accesso!",
      },
      metaInfo: { title: "Piattaforma - Registrazione" },
    },
    register2fa: {
      generatingQrCode: "Generazione del codice QR...",
      incorrectCode: " Il codice non è corretto. Riprova.",
      need2fa:
        'Per accedere alla piattaforma, imposta l\'autenticazione a 2 fattori (2FA). Scansiona il codice QR qui sotto o inserisci la chiave segreta fornita in un\'app di autenticazione, come "Google Authenticator" o "Microsoft Authenticator".',
      title: "Imposta autenticazione a 2 fattori",
      verify: "Verifica",
      verifying: "Verifica in corso...",
    },
    resetPassword: {
      title: "Reimposta password",
      sendEmail: "Invia email",
      dialog: {
        internalErrorText: "Si è verificato un errore interno. Contattaci.",
        resetEmailSent: {
          title: "Email di reimpostazione inviata",
          text: (ctx) =>
            `Un'email di reimpostazione è stata inviata alla casella di posta di ${ctx.named(
              "email"
            )}. Se non appare a breve, controlla la cartella spam.`,
        },
        unknownEmail: {
          title: "L'email non esiste",
          text: "L'email fornita per reimpostare la password non esiste. Per creare un account con questa email, vai alla pagina di registrazione.",
        },
      },
      metaInfo: { title: "Piattaforma - Reimposta Password" },
    },
  },
  compliance: {
    investorProfile: {
      agreeAndConfirmSelection: "Accetta e conferma selezione",
      byClickingAcceptDisclaimer:
        "Cliccando il pulsante qui sotto, confermo di aver letto e accettato il disclaimer sopra e accetto i {0} e la {1} di questa piattaforma.",
      pleaseChooseProfile:
        "Scegli il tuo paese di domicilio e il profilo investitore per procedere.",
      privacyPolicy: "politica sulla privacy",
      termsOfUse: "termini di utilizzo",
      title: "Profilo investitore",
      metaInfo: {
        title: "Piattaforma - Profilo Investitore",
      },
    },
    ombudsman: {
      title: "Ombudsman",
      metaInfo: {
        title: "Piattaforma - Ombudsman",
      },
    },
    privacyPolicy: {
      endDate: "Crissier, 31 agosto 2023",
      title: "Politica sulla Privacy",
      metaInfo: { title: "Piattaforma - Politica sulla privacy" },
      introductionParagraph: {
        title: "Introduzione",
        para1:
          "Alquant SA (di seguito denominata Alquant, 'noi', 'ci') è la società che gestisce questa piattaforma. Alquant SA rispetta la privacy degli utenti della sua presenza web. Ciò significa che i dati personali vengono raccolti, elaborati e utilizzati in conformità con le disposizioni della legge applicabile sulla protezione dei dati e sulla base di questa politica sulla privacy.",
        para2:
          "Ciò vale anche - e in particolare - per la collaborazione con partner e terze parti che utilizziamo per l'elaborazione dei contratti.",
        para3:
          "Accettando la seguente politica sulla privacy, acconsenti ai processi di gestione dei dati di Alquant descritti di seguito per quanto riguarda la raccolta, l'elaborazione e l'uso dei dati in conformità con le leggi sulla protezione dei dati e le seguenti disposizioni. Questo consenso può essere revocato in qualsiasi momento con effetto futuro.",
        para4:
          "La nostra pratica di protezione dei dati è quindi coerente con la nuova Legge federale sulla protezione dei dati (nLPD) e, ove applicabile, il Regolamento generale sulla protezione dei dati dell'UE (GDPR).",
      },
      accountableAuthorityParagraph: {
        title: "Autorità responsabile / Rappresentante UE",
        switzerland: "Svizzera",
        euRepresentativeSub: {
          title: "Rappresentante UE",
          para1:
            "Nei casi di cui all'articolo 3, paragrafo 2 del Regolamento (UE) 2016/679 (Regolamento generale sulla protezione dei dati; GDPR) e in conformità con l'articolo 27 del GDPR, è designato come rappresentante nell'UE e in riferimento al requisito svizzero nLPD della funzione di Responsabile della protezione dei dati:",
          para3: "Puoi contattare il nostro rappresentante UE all'indirizzo: info(at)alquant.com",
        },
        accountableAuthoritySub: {
          email: "Email",
          phone: "Telefono",
          title: "Autorità responsabile e funzione Privacy dei Dati secondo nLPD svizzera",
          para1: "La responsabilità per il trattamento dei dati personali è di:",
          para3:
            "Per qualsiasi richiesta relativa alla protezione delle tue informazioni personali, contatta il nostro responsabile della privacy all'indirizzo: compliance(at)alquant.com.",
        },
      },
      personalDataParagraph: {
        title: "Dati Personali",
        para1:
          "I dati personali sono qualsiasi informazione relativa a una persona fisica identificata o identificabile; si considera identificabile una persona fisica che può essere identificata direttamente o indirettamente, in particolare mediante riferimento a un identificativo come il nome, un numero di identificazione, dati relativi all'ubicazione, un identificativo online o uno o più elementi caratteristici della sua identità fisica, fisiologica, genetica, psichica, economica, culturale o sociale. Ciò include, ad esempio, il tuo nome, il tuo numero di telefono, il tuo indirizzo, nonché tutti i dati di inventario che ci fornisci al momento della registrazione e della creazione del tuo account cliente. I dati statistici o anonimizzati, che raccogliamo, ad esempio, quando visiti il nostro negozio web e che non possono essere collegati direttamente alla tua persona, non sono coperti qui.",
      },
      purposeOfDataCollectionParagraph: {
        title: "Scopi della Raccolta Dati",
        para1:
          "a) La raccolta e l'elaborazione di questi dati vengono effettuate ai fini dell'adempimento contrattuale, per consentire l'uso del nostro sito web (instaurazione della connessione), per garantire la sicurezza e la stabilità del sistema su base permanente, per ottimizzare la nostra presenza web e per scopi statistici interni. Raccogliamo, conserviamo ed elaboriamo i dati personali esclusivamente in conformità con le normative legali applicabili e nella misura in cui ciò sia necessario e richiesto per adempiere e migliorare gli obblighi di prestazione contrattuale tra noi e l'utente / cliente. Ciò include anche la conservazione dei dati per eventuali richieste di garanzia dopo la fine del contratto.",
        para2:
          "b) Inoltre, utilizziamo i tuoi dati nell'ambito della legge applicabile per i nostri scopi di marketing al fine di ottimizzare la nostra presenza web e per attirare la tua attenzione su servizi che potrebbero essere di particolare interesse per te.",
        para3:
          "c) Inoltre, la raccolta, l'elaborazione e l'uso dei dati personali avvengono solo se hai dato il tuo consenso.",
      },
      newsletterParagraph: {
        title: "Newsletter",
        para1:
          "Alquant ama informarti regolarmente su argomenti attuali e progetti riguardanti il nostro campo di attività tramite la newsletter. Riceverai una newsletter da noi solo su richiesta espressa. Utilizziamo il processo opt-in per inviare la newsletter, il che significa che riceverai la nostra newsletter via email a condizione che tu ti sia precedentemente registrato esplicitamente per la consegna della newsletter. Quando ti sei registrato alla newsletter, il tuo indirizzo email verrà utilizzato insieme al tuo consenso per i nostri scopi promozionali fino a quando non ti disiscrivi dalla newsletter. Puoi disiscriverti in qualsiasi momento inviando un'email specificandolo al nostro indirizzo di contatto info(at)alquant.com. Siamo autorizzati a incaricare terzi per la gestione tecnica delle attività promozionali e siamo autorizzati a trasmettere i tuoi dati a questo scopo.",
        para2:
          "I dati da te forniti al momento della registrazione alla newsletter (nome e indirizzo email) saranno conservati e utilizzati solo per inviare la newsletter.",
      },
      legalBasisParagraph: {
        title: "Base legale per il trattamento",
        para1:
          "Trattiamo i tuoi dati personali principalmente per adempiere agli obblighi contrattuali e ai nostri obblighi legali. Inoltre, accettando questa politica sulla privacy, acconsenti a tutte le operazioni di trattamento specificate in questa politica sulla privacy. Naturalmente puoi revocare il tuo consenso in qualsiasi momento; è sufficiente una dichiarazione a compliance(at)alquant.com. Qualsiasi trattamento effettuato fino a questo momento non sarà influenzato dalla tua cancellazione.",
      },
      legitimateInterestParagraph: {
        title: "Interessi legittimi per il trattamento",
        para1:
          "Oltre alla suddetta base legale per il trattamento dei dati, trattiamo i dati anche in base ai nostri legittimi interessi. Ciò si applica in particolare, ma non è limitato a, al trattamento per scopi di marketing e promozionali. Perseguiamo, in particolare, i seguenti interessi:",
        list1: {
          el1: "garantire l'uso potenziale del sito web",
          el2: "prevenire le frodi",
          el3: "garantire la sicurezza e la stabilità dei sistemi IT",
          el4: "i nostri scopi di marketing",
          el5: "scopi statistici interni",
        },
      },
      disclosureParagraph: {
        title: "Divulgazione",
        para1:
          "Divulghiamo i tuoi dati personali solo se hai dato il tuo consenso espresso, se vi è un obbligo legale a farlo o se ciò è richiesto per far valere i nostri diritti – in particolare, per far valere pretese derivanti dal rapporto contrattuale. Inoltre, divulghiamo i tuoi dati a terzi, nella misura in cui è richiesto per l'esecuzione del contratto. Divulghiamo i dati necessari a filiali, società di trasporto, banche e altri fornitori di servizi a questo scopo. Questi fornitori di servizi utilizzano i tuoi dati esclusivamente per l'elaborazione degli ordini e non per altri scopi. Inoltre, utilizziamo alcuni servizi forniti da fornitori di servizi esterni per ottimizzare la tua visita al nostro sito web. È garantito (contrattualmente) che questi fornitori di servizi trattino i tuoi dati in modo confidenziale e in conformità con le normative legali applicabili, e che i tuoi dati siano utilizzati solo per lo scopo del rispettivo servizio. Qualsiasi trasferimento o rivendita dei dati a terzi da parte di Alquant oltre le disposizioni di questa politica sulla privacy è esclusa a meno che l'utente non abbia dato il proprio consenso espresso alla divulgazione dei propri dati. In questo caso, l'utente può revocare questo consenso in qualsiasi momento. Le operazioni di trattamento precedentemente eseguite sulla base del tuo consenso non saranno influenzate.",
        para2:
          "Alquant è autorizzata a trasmettere i tuoi dati personali a terzi all'estero se ciò è richiesto per l'esecuzione del contratto. Queste terze parti sono vincolate allo stesso livello di protezione dei dati del fornitore. Se il livello di protezione dei dati in un paese non corrisponde al livello svizzero, garantiamo contrattualmente che la protezione dei tuoi dati personali corrisponda in ogni momento a quella in Svizzera.",
      },
      singleSignOnProcedureParagraph: {
        title: "Uso delle procedure di single sign-on",
        para1:
          "Sul nostro sito web, se hai un profilo Google o Microsoft, puoi iscriverti per creare un account cliente o registrarti utilizzando il plugin sociale utilizzando la tecnica Single Sign On. I plugin sono contrassegnati con il logo del fornitore.",
        para2:
          "Quando richiami i nostri siti web che contengono un tale plugin, il tuo browser stabilisce una connessione diretta con i computer del fornitore. Il contenuto del plugin viene trasmesso dal sito del fornitore direttamente al tuo browser, che lo integra nel sito web. Integrando i plugin, il fornitore riceve l'informazione che hai richiamato il nostro sito web. Se sei contemporaneamente connesso al fornitore, il fornitore può assegnare la visita al tuo profilo.",
        para3:
          "Se non vuoi che il fornitore raccolga dati su di te tramite il nostro sito web, devi disconnetterti dal fornitore prima di visitare il nostro sito web. Anche se sei disconnesso, i fornitori raccolgono dati anonimizzati tramite plugin sociali impostando un cookie per te. Se accedi al fornitore in un momento successivo, questi dati possono essere assegnati al tuo profilo.",
        para4:
          "Se viene fornito un login tramite un servizio di social login − ad es. Google Connect – i dati vengono scambiati tra il fornitore e il nostro sito web. Nel caso di Google Connect, ciò può essere, ad esempio, dati dal tuo profilo Google pubblico. Utilizzando tali servizi di login acconsenti al trasferimento dei dati.",
        para5:
          "Fai riferimento alle informative sulla protezione dei dati del fornitore per lo scopo e l'ambito della raccolta dati e l'ulteriore trattamento dei tuoi dati da parte del fornitore, nonché i tuoi rispettivi diritti e opzioni di configurazione per proteggere la tua privacy.",
        para7:
          "Se non vuoi che il fornitore raccolga dati su di te tramite questi cookie, puoi selezionare la funzione “blocca cookie di terze parti\" nelle impostazioni del tuo browser. Quindi, se c'è contenuto incorporato da altri fornitori, il browser non invia alcun cookie al server.",
      },
      durationOfRetentionParagraph: {
        title: "Durata della conservazione",
        para1:
          "Conserviamo i tuoi dati personali per tutto il tempo necessario per rispettare le leggi applicabili, o come riteniamo opportuno, o finché è richiesto per gli scopi per cui sono stati raccolti. Bloccheremo o elimineremo i tuoi dati personali non appena non saranno più necessari e definitivamente alla scadenza del periodo massimo di conservazione legale.",
        para2:
          "Puoi richiedere che i tuoi dati personali vengano eliminati in qualsiasi momento inviandoci una richiesta corrispondente a compliance(at)alquant.com. Soddisferemo la tua richiesta prontamente a condizione che non siamo tenuti a conservarli per altri motivi o ne abbiamo bisogno, ad esempio per far valere pretese.",
      },
      furtherDataSourcesParagraph: {
        title: "Ulteriori fonti di dati",
        para1:
          "Oltre ai dati che raccogliamo direttamente da te, otteniamo dati anche da registri pubblici (come il Registro di Commercio) e da fornitori terzi.",
        para2:
          "Poiché le fonti di dati variano a seconda del cliente, non è possibile fornire informazioni generali riguardo a tali fonti. Se lo desideri, siamo naturalmente disposti a divulgarti le nostre fonti di dati in dettaglio.",
      },
      userRightsParagraph: {
        title: "Diritti dell'utente",
        rightRevocationSub: {
          title: "Diritto di Revoca",
          para1:
            "Nella misura in cui ci hai dato il consenso per raccogliere, conservare e utilizzare dati personali riguardo al sito web o ai nostri servizi, puoi revocare questo consenso in qualsiasi momento. La revoca può essere inviata via email o per iscritto al contatto sopra nella sezione 2: Autorità Responsabile. Gli effetti della revoca sono limitati alla conservazione e all'uso dei dati personali, che non possono essere conservati e utilizzati senza il tuo previo consenso basato su autorizzazione legale. La revoca non ha inoltre alcun effetto sulle procedure di trattamento precedenti effettuate sulla base del consenso.",
        },
        furtherRightsSub: {
          title: "Ulteriori diritti",
          informationSub: {
            title: "Informazioni",
            para1:
              "Su richiesta scritta, ti forniremo informazioni in qualsiasi momento sui tuoi dati personali memorizzati. La richiesta di informazioni deve essere fatta per iscritto e con prova di identità (copia del documento d'identità, passaporto o altro documento di identificazione ufficiale). L'esercizio di questo diritto è gratuito una volta all'anno; per ogni ulteriore richiesta, ci riserviamo il diritto di addebitare i costi sostenuti.",
          },
          correctionSub: {
            title: "Correzione, cancellazione, limitazione del trattamento",
            para1:
              "Inoltre, hai la possibilità di far correggere, bloccare o eliminare i tuoi dati personali da noi in qualsiasi momento. Contatta l'autorità interna, i cui dettagli possono essere trovati nella sezione 2. Esclusi dalla cancellazione sono solo i dati di cui abbiamo bisogno per il completamento di compiti in sospeso o per l'applicazione di diritti e pretese esistenti, nonché i dati che siamo obbligati a conservare a causa di normative legali. Tali dati saranno bloccati.",
          },
          rightAppealSub: {
            title: "Diritto di appello",
            para1:
              "Diamo grande importanza alla salvaguardia dei diritti dei nostri clienti e quindi anche alla protezione dei tuoi dati personali. Tuttavia, se ritieni che trattiamo i tuoi dati illegalmente, puoi contattarci in qualsiasi momento al +41 41 661 23 45 o via email compliance(at)alquant.com con i dettagli della tua preoccupazione. Affronteremo le tue preoccupazioni al meglio delle nostre capacità.",
            para2:
              "Se, contrariamente alle aspettative, il nostro servizio clienti non può fornirti un'assistenza soddisfacente, puoi inviare la tua preoccupazione all'Incaricato federale della protezione dei dati e della trasparenza in qualsiasi momento come reclamo formale, che verrà poi esaminato.",
          },
          dataPortabilitySub: {
            title: "Portabilità dei dati",
            para1:
              "Su richiesta scritta, hai anche il diritto di ricevere i dati personali che ti riguardano in un formato strutturato, attuale e leggibile da dispositivo automatico (file pdf) per la trasmissione a una terza parte. Ci riserviamo il diritto di addebitare i costi sostenuti.",
          },
        },
      },
      cookiesParagraph: {
        title: "Uso dei Cookie",
        para1:
          "Per migliorare la nostra gamma di prodotti, utilizziamo cookie sul nostro sito web. Un cookie è un piccolo file di testo che viene trasferito sul tuo computer quando navighi nelle nostre pagine. Un cookie può contenere solo informazioni che inviamo al tuo dispositivo elettronico – non possono essere utilizzati per leggere dati personali. Se accetti i cookie sul nostro sito, non abbiamo accesso alle tue informazioni personali ma con l'aiuto dei cookie possiamo identificare il tuo computer. Non ci sono dati personali memorizzati nei cookie utilizzati in modo che non possiamo trarre conclusioni sulla tua identità mediante la tecnologia dei cookie. Vengono generate solo informazioni pseudonimizzate.",
        para2: "Utilizziamo i cookie per verificare che tu rispetti i nostri Termini di Utilizzo.",
        para3:
          "Utilizziamo cookie temporanei basati sulla sessione: questi non rimangono sul tuo computer. Quando lasci le nostre pagine, anche il cookie temporaneo verrà scartato. Con l'aiuto delle informazioni raccolte, possiamo analizzare i modelli di utilizzo e le strutture del nostro sito web e ottimizzarlo migliorando il contenuto o la personalizzazione e semplificando l'uso.",
        para4:
          "Inoltre, utilizziamo cookie persistenti: questi rimangono sul tuo computer per semplificare lo shopping, la personalizzazione e i servizi di registrazione alla tua prossima visita. Ad esempio, questi cookie possono registrare ciò che hai scelto di acquistare mentre continui a fare acquisti. Inoltre, devi inserire la tua password solo una volta sulle pagine web che richiedono il login. I cookie persistenti possono essere rimossi manualmente dall'utente. Si eliminano da soli dopo che è trascorso un certo tempo.",
        para5:
          "I cookie sono utilizzati anche da alcuni dei nostri partner pubblicitari (cookie di terze parti). Questi cookie ci aiutano ad adattare il nostro sito alle esigenze specifiche dei nostri clienti, ad esempio, mostrando pubblicità che potrebbero effettivamente interessarti. L'uso di questi cookie ci consente di raccogliere informazioni su quali prodotti hai visualizzato o cercato o quali pagine hai visitato in precedenza. Questi cookie sono memorizzati sul tuo disco rigido e si eliminano da soli dopo un certo tempo. Non ci sono anche informazioni personali memorizzate nei cookie utilizzati dai nostri partner pubblicitari. L'uso è pseudonimizzato in modo che non venga tratta alcuna conclusione sulla tua identità.",
        para6:
          "La maggior parte dei browser (come Firefox, Chrome, Internet Explorer, Safari, ecc.) accetta i cookie per impostazione predefinita. Puoi consentire o bloccare i cookie temporanei e persistenti nelle impostazioni di sicurezza - indipendentemente l'uno dall'altro. Tuttavia, dovremmo sottolineare che alcune funzionalità non sono disponibili sul nostro sito web e alcuni siti web potrebbero non essere visualizzati correttamente se disabiliti i cookie.",
        para7:
          "I dati memorizzati nei nostri cookie non saranno collegati ai tuoi dati personali (nome, indirizzo ecc.) senza il tuo consenso espresso.",
      },
      liabilityForLinksParagraph: {
        title: "Responsabilità per i link",
        para1:
          "Alquant dichiara espressamente con la presente che al momento dell'inserimento dei link non erano identificabili contenuti illegali sulle pagine da collegare. Non abbiamo alcuna influenza sul design attuale e futuro, sul contenuto o sulla paternità delle pagine collegate. Pertanto, ci dissociamo espressamente con la presente da tutti i contenuti di tutte le pagine collegate che vengono modificati dopo l'inserimento del link. Questa dichiarazione si applica a tutti i link e riferimenti sulla nostra presenza web. Per contenuti illegali, errati o incompleti e in particolare, per danni derivanti dall'uso o non uso di tali informazioni, è responsabile solo il fornitore della pagina a cui si è fatto riferimento e non chi semplicemente inserisce il link alla rispettiva pubblicazione.",
      },
      webAnalysisParagraph: {
        title: "Analisi web",
        googleAnalyticsSub: {
          title: "Google Analytics",
          para1:
            "Questo sito web utilizza Google Analytics, un servizio di analisi web fornito da Google Inc. (Google) per la progettazione di siti web basata sulle esigenze. Riceviamo solo valutazioni dei dati senza riferimenti personali.",
          para2:
            "Google Analytics utilizza i cookie: file di testo che vengono memorizzati sul tuo computer e che consentono l'analisi del tuo utilizzo del sito web. Le informazioni generate dal cookie sul tuo utilizzo di questo sito web (incluso il tuo indirizzo IP) verranno trasmesse e memorizzate sui server di Google negli Stati Uniti. L'anonimizzazione IP è stata attivata su questo sito web in modo che l'indirizzo IP degli utenti di Google all'interno degli Stati Membri dell'Unione Europea o in altri stati contraenti dell'Accordo sullo Spazio Economico Europeo venga troncato prima della trasmissione. Solo in casi eccezionali l'indirizzo IP completo verrà inviato a un server Google negli USA e lì troncato. Google utilizzerà queste informazioni per conto dell'operatore del sito web per valutare l'uso del sito web da parte degli utenti, per compilare report sull'attività del sito web e per fornire altri servizi all'operatore del sito web relativi all'attività del sito web e all'uso di internet. Google trasmetterà anche queste informazioni a terzi se richiesto dalla legge o se terzi elaborano questi dati per conto di Google. Google non assocerà mai il tuo indirizzo IP ad altri dati Google.",
          para3:
            "Puoi impedire l'installazione dei cookie impostando il software del tuo browser di conseguenza. Tuttavia, dovremmo sottolineare che in questo caso potresti non essere in grado di utilizzare tutte le funzioni di questo sito web nella misura completa. Utilizzando questo sito web, acconsenti al trattamento dei dati raccolti su di te da Google nel modo e per gli scopi sopra indicati.",
          para4:
            'Inoltre, puoi impedire a Google di raccogliere i dati generati dal cookie e relativi al tuo utilizzo del sito web (incluso il tuo indirizzo IP) e l\'elaborazione di questi dati da parte di Google scaricando e installando il plugin del browser disponibile su <a href="https://tools.google.com/dlpage/gaoptout" >https://tools.google.com/dlpage/gaoptout</a >. Per ulteriori informazioni sui Termini di utilizzo e sulla Politica sulla privacy di Google Analytics, vedi',
          para5:
            '<a href="https://www.google.com/analytics/terms/" >https://www.google.com/analytics/terms/</a > e',
          para6:
            '<a href="https://policies.google.com/privacy?hl=en" >https://policies.google.com/privacy?hl=en</a >',
        },
        googleFontsSub: {
          title: "Google Fonts",
          para1:
            'Questo sito web utilizza anche Google Fonts (Open Scans). Per motivi tecnici, il tuo indirizzo IP deve essere trasmesso a Google affinché i font possano essere trasferiti al tuo browser. Per ulteriori informazioni su Google Fonts, visita <a class="break-all" href="https://developers.google.com/fonts/faq#what_does_using_the_google_fonts_api_mean_for_the_privacy_of_my_users" >https://developers.google.com/fonts/faq#what_does_using_the_google_fonts_api_mean_for_the_privacy_of_my_users</a > .',
        },
      },
      securityMeasureParagraph: {
        title: "Misure di sicurezza",
        para1:
          "Applichiamo misure di sicurezza tecniche e organizzative per proteggere adeguatamente le tue informazioni personali da accesso non autorizzato, abuso, manipolazione accidentale o intenzionale, perdita o distruzione. Per proteggere la tua privacy, utilizziamo una connessione sicura per il nostro sito web, che puoi vedere dall'‘https’ (https sta per Hypertext Transfer Protocol Secure) all'inizio della barra degli indirizzi nel tuo browser. In questo modo, la connessione è crittografata via SSL/TSL e i tuoi dati non possono essere intercettati da terzi. Le misure di sicurezza tecniche per proteggere i tuoi dati personali vengono regolarmente controllate e, se necessario, aggiornate. Questi principi si applicano anche alle aziende che trattano e utilizzano i dati personali per nostro conto e secondo le nostre istruzioni.",
      },
      legalBasisGeneralDataProtectionParagraph: {
        title: "Base legale Regolamento Generale sulla Protezione dei Dati",
        para1:
          "In conformità con le disposizioni del Regolamento generale sulla protezione dei dati (GDPR) applicabile dal 25 maggio 2018, ti informiamo che il tuo consenso all'invio all'indirizzo email che fornisci sarà dato sulla base dell'Art. 6 para. 1 lit. a e Art. 7 GDPR. La lista di invio corrispondente è utilizzata sulla base dei nostri legittimi interessi in conformità con l'Art. 6 para. 1 lit. f GDPR. Siamo interessati a utilizzare un sito web e un sistema sicuri e facili da usare che servano i nostri interessi commerciali ma soddisfino anche le aspettative dei nostri utenti e clienti.",
      },
      changesParagraph: {
        title: "Modifiche",
        para1:
          "Ci riserviamo il diritto di modificare questa politica sulla privacy in qualsiasi momento. La politica sulla privacy non costituisce alcun rapporto contrattuale o altro rapporto legale formale con o per conto di alcuna parte.",
      },
    },
    termsOfUse: {
      endDate: "Crissier, 3 febbraio 2022",
      title: "Termini di Utilizzo",
      metaInfo: { title: "Piattaforma - Termini di utilizzo" },
      declarationOfAcceptanceParagraph: {
        title: "Dichiarazione di accettazione da parte dell'utente",
        para1:
          'Questo sito web è gestito da Alquant SA. Utilizzando questo sito web (o una pagina reindirizzata a questo indirizzo web; di seguito denominato in toto "sito web Alquant") confermi di aver letto e compreso e di accettare i seguenti Termini di Utilizzo incluse le Condizioni Legali. Se non accetti questi Termini di Utilizzo, ti preghiamo di non visitare nuovamente il sito web Alquant.',
      },
      limitedAccessParagraph: {
        title: "Accesso limitato",
        para1:
          "Il sito web Alquant non è destinato a persone giuridiche e fisiche che, per motivi di nazionalità, sede aziendale, luogo di residenza o per qualsiasi altro motivo, sono soggette a un ordinamento giuridico che vieta o limita in particolare",
        list1: {
          el1: "la pubblicazione dei contenuti,",
          el2: "l'accesso al sito web Alquant,",
          el3: "le attività di un fornitore di servizi finanziari estero,",
          el4: "l'ammissione di prodotti finanziari (es. certificati o fondi).",
        },
        para3:
          "Inoltre, non è destinato all'uso da parte di persone giuridiche o fisiche in paesi in cui Alquant SA o qualsiasi società ad essa associata non dispongono della registrazione e autorizzazione necessarie per operare.",
        para4:
          "Le persone soggette a una o tutte queste restrizioni non possono accedere al sito web Alquant. Ciò vale in particolare per i cittadini di USA, Regno Unito, Canada, Giappone, Cina e Singapore, o persone residenti nei paesi summenzionati. Si prega di informarsi sulle corrispondenti restrizioni legali nel proprio paese.",
        para5: "Avviso per investitori istituzionali",
        para6:
          "I prodotti finanziari per investitori professionali sono disponibili solo per investitori qualificati. Ai sensi dell'Art. 10, cpv. 3, della Legge sugli investimenti collettivi di capitale insieme all'Art. 6 dell'Ordinanza sugli investimenti collettivi di capitale, gli investitori qualificati includono investitori istituzionali con tesoreria professionale, vale a dire banche e commercianti di titoli (inclusi i loro clienti che hanno un contratto di gestione patrimoniale scritto), fondi pensione, compagnie di assicurazione, gestori di fondi e autorità locali e cantonali, nonché società industriali e commerciali. Selezionando \"Investitori professionali\" confermi di essere un investitore qualificato secondo la definizione sopra riportata.",
      },
      propertyRightsParagraph: {
        title: "Diritti di proprietà",
        para1:
          "Tutti gli elementi sul sito web Alquant sono protetti come proprietà immateriale e sono di proprietà di Alquant SA o di terzi. L'utilizzo del sito web Alquant non comporta il trasferimento di alcun diritto, in particolare alcun diritto relativo a software, nomi di marchi o elementi del sito web Alquant. Le indicazioni di copyright e i nomi di marchi non possono essere modificati o rimossi. Gli elementi del sito web Alquant non possono essere riprodotti interamente o in parte senza riferimento alla fonte completa. I contenuti del sito web Alquant non possono essere riprodotti o utilizzati per scopi pubblici o commerciali senza il previo accordo scritto di Alquant SA.",
      },
      consultingReplacementParagraph: {
        title: "Non sostituisce la consulenza",
        para1:
          "Le informazioni e le opinioni pubblicate sul sito web Alquant sono di natura generale. Non sono né destinate né adatte a sostituire la consulenza individuale da parte di personale specializzato che terrà conto delle circostanze effettive prevalenti in un determinato caso individuale. Per questo motivo non rappresentano consulenza legale, fiscale, finanziaria, economica o di altro tipo e non devono essere utilizzate come aiuto agli investimenti.",
      },
      noOffersParagraph: {
        title: "Nessuna offerta",
        para1:
          "Le informazioni e le opinioni pubblicate sul sito web Alquant non costituiscono pubblicità o raccomandazioni e non devono essere interpretate come una richiesta, un'offerta o un invito a presentare un'offerta:",
        list1: {
          el1: "per l'acquisto o la vendita di strumenti di investimento,",
          el2: "per effettuare qualsiasi tipo di transazione,",
          el3: "per completare qualsiasi altro tipo di affare legale.",
        },
        para3: "L'unico scopo del sito web Alquant è fornire informazioni.",
      },
      futurePerformanceParagraph: {
        title: "Performance futura (indicazione di rischio)",
        para1:
          "La performance futura di uno strumento di investimento non può essere dedotta dai movimenti passati del tasso, in altre parole, il titolo può salire o scendere. Come si è comportato il titolo in passato non è quindi garanzia del suo valore futuro. Nel caso di determinati strumenti di investimento, è possibile anche la perdita dell'intero capitale investito in casi estremi. Inoltre, le fluttuazioni dei tassi di cambio possono anche influenzare l'investimento.",
      },
      noGuaranteeParagraph: {
        title: "Nessuna garanzia",
        para1:
          "Alquant SA non offre garanzie (inclusa la responsabilità verso terzi) né assicurazioni per",
        list1: {
          el1: "l'attualità, la precisione, l'affidabilità o la completezza dei contenuti del sito web Alquant,",
          el2: "i risultati ottenuti utilizzando il sito web Alquant,",
          el3: "i contenuti di terzi che si trovano su o sono accessibili tramite il sito web Alquant.",
        },
        para3: "Inoltre, Alquant SA non sarà ritenuta responsabile e non può garantire che",
        list2: {
          el1: "le funzioni sul sito web Alquant funzionino senza errori e siano disponibili senza interruzioni,",
          el2: "il sito web Alquant e altri componenti utilizzati tramite l'accesso al sito web Alquant siano privi di virus, ecc.",
        },
        para5: "Alquant SA non offre inoltre alcuna garanzia per",
        list3: {
          el1: "l'aumento o la stabilità del valore del capitale investito in strumenti di investimento,",
          el2: "il livello dei dividendi futuri.",
        },
      },
      linksParagraph: {
        title: "Link",
        para1:
          "Alquant SA non ha verificato i siti web di terzi collegati al sito web Alquant e non può essere ritenuta responsabile per l'attualità, la precisione, l'affidabilità, la completezza o la legalità dei contenuti e delle offerte su tali siti web. L'utente accede quindi a tali pagine web a proprio rischio.",
        para2:
          "I link web possono essere inclusi in siti web esterni a un sito web Alquant solo con il previo accordo di Alquant SA.",
      },
      serviceChangesParagraph: {
        title: "Modifiche al servizio",
        para1:
          "Alquant SA può modificare, sospendere o interrompere qualsiasi aspetto dei Servizi in qualsiasi momento, inclusa la disponibilità di qualsiasi funzionalità del Servizio, database o contenuto. Alquant SA può anche imporre limiti a determinate funzionalità e servizi o limitare l'accesso dell'utente a tutto o parte dei Servizi senza preavviso.",
        para2:
          "Alquant SA si riserva il diritto a sua esclusiva discrezione di terminare l'accesso dell'utente ai Servizi senza preavviso.",
      },
      useOfInformationParagraph: {
        title: "Uso delle informazioni",
        para1:
          "L'utente può utilizzare le Informazioni pubblicate sul sito web Alquant solo per uso aziendale interno o per uso personale e non commerciale. In nessun caso l'utente potrà pubblicare, vendere, affittare, diffondere, ritrasmettere, ridistribuire, trasmettere, far circolare o altrimenti riprodurre, fornire o consentire l'accesso a qualsiasi Informazione di <b>Alquant SA</b> in qualsiasi formato a chiunque; a condizione, tuttavia, che l'utente possa fornire Informazioni agli utenti, su base non continuativa, utilizzando solo i seguenti metodi limitati: (a) In pubblicità scritte, corrispondenza o altra letteratura, o (b) durante conversazioni telefoniche vocali che non comportano voce computerizzata, sistemi di richiesta informazioni automatizzati o tecnologie simili.",
        para2:
          "L'uso di strumenti di scripting automatizzati per scansionare il sito o tentare di aggirare l'API è severamente vietato e può comportare il blocco dal sito web Alquant. Le richieste eccessive possono comportare la limitazione dell'accesso ai dati del tuo account.",
        para3:
          "L'uso di forme di automazione non basate su API, come lo scripting del sito web, è vietato. L'uso di queste tecniche può comportare la sospensione permanente del tuo account.",
      },
      indemnificationParagraph: {
        title: "Indennizzo",
        para1:
          "L'utente (e il fondo dell'utente, se l'utente è un rappresentante di un fondo) accettano congiuntamente e solidalmente di indennizzare e tenere indenne <b>Alquant SA</b>, e i suoi agenti, fornitori di informazioni e i loro agenti, rappresentanti, direttori, funzionari, azionisti, partner, predecessori, successori e cessionari, da e contro qualsiasi reclamo o domanda, procedimento, danni, responsabilità, perdite o spese, derivanti da reclami fatti da terzi, derivanti dall'uso da parte dell'utente delle informazioni di <b>Alquant SA</b> che costituisce una violazione dei Termini di Utilizzo o un atto o omissione improprio.",
        para2:
          "Se un utente fa uso dei Servizi o di qualsiasi Contenuto diverso da quanto espressamente consentito ai sensi dei presenti Termini di Utilizzo, egli può violare il copyright e altre leggi e può essere soggetto a sanzioni. Senza limitare le frasi precedenti, l'utente non dovrà:",
        para3:
          "Impegnarsi o consentire qualsiasi rivendita, visualizzazione, riproduzione, copia, traduzione, modifica, adattamento, creazione di opere derivate da, distribuzione, trasmissione, trasferimento, ripubblicazione, compilazione, decompilazione o reverse engineering dei Servizi, qualsiasi Contenuto, qualsiasi parte di esso, o qualsiasi dato, altro contenuto o informazione fornita all'utente in relazione all'uso dei Servizi da parte di Alquant SA o di una qualsiasi delle sue fonti terze, in qualsiasi forma, media o tecnologia ora esistente o sviluppata in seguito o su qualsiasi rete, inclusa una rete locale; Rimuovere, oscurare o alterare qualsiasi avviso, disclaimer o altra divulgazione apposta o contenuta all'interno dei Servizi, incluso qualsiasi avviso di copyright, marchio o altro avviso di diritti proprietari o qualsiasi altro avviso legale apposto o visualizzato in associazione con il Contenuto; Creare un frame o utilizzare tecniche di framing per racchiudere qualsiasi parte dei Servizi o del Contenuto, senza previo consenso scritto espresso da Alquant SA;",
        para4:
          "Impersonare qualsiasi persona, o dichiarare falsamente o altrimenti rappresentare in modo errato la propria affiliazione con qualsiasi persona, in relazione a qualsiasi uso dei Servizi; Violare o tentare di violare la sicurezza dei Servizi o di qualsiasi rete, server, dati o computer o altro hardware relativo o utilizzato in relazione ai Servizi o a uno qualsiasi dei Contenuti, gestito o meno da Alquant SA o da terzi; né utilizzare con, o distribuire tramite, i Servizi qualsiasi software o altri strumenti o dispositivi progettati per interferire con o compromettere la privacy, la sicurezza o l'uso dei Servizi da parte di altri o le operazioni o le attività di qualsiasi persona;",
        para5:
          "Violare qualsiasi legge applicabile, incluse, ma non limitate a leggi sui titoli e leggi che regolano l'attività di investimento in qualsiasi paese; Limitare o inibire qualsiasi altro utente autorizzato dall'utilizzare e godere dei Servizi; Pubblicare, trasmettere, riprodurre, distribuire o sfruttare in qualsiasi modo uno qualsiasi dei Contenuti o altre informazioni o altri materiali ottenuti tramite i Servizi per scopi commerciali diversi da quanto espressamente consentito dai presenti Termini di Utilizzo o da espresso permesso preventivo di Alquant SA.",
      },
      exclusionLiabilityParagraph: {
        title: "Esclusione di responsabilità",
        para1:
          "Alquant SA o qualsiasi azienda, partner, consiglio di amministrazione, dipendente o rappresentante ad essa collegato rifiuta ogni responsabilità (inclusa per negligenza e verso terzi) per danni diretti o indiretti o danni consequenziali che possono verificarsi in connessione diretta o indiretta con l'utilizzo del sito web Alquant.",
      },
      reservationsParagraph: {
        title: "Riserve",
        para1:
          "Alquant SA si riserva il diritto di modificare qualsiasi informazione, opinione, performance o altri dati, link, ecc. in qualsiasi momento senza preavviso agli utenti.",
        para2:
          "Inoltre, i Termini di Utilizzo possono anche essere modificati e l'uso del sito web Alquant può anche essere limitato o terminato senza preavviso.",
      },
      placeOfJurisdictionParagraph: {
        title: "Foro competente",
        para1:
          "Nella misura in cui sorge una posizione giuridica tra Alquant SA e gli utenti del sito web Alquant, questa è soggetta alla legislazione svizzera. L'unico foro competente sarà Losanna, Svizzera.",
      },
    },
  },
  errors: {
    backHome: "Torna alla Home",
    error403: {
      paragraphWhenLoggedIn:
        "Non hai il permesso di accedere a questa pagina. Se il tuo profilo è accettato, un admin ti darà presto i diritti per accedervi. Controlla nei prossimi 1-2 giorni lavorativi.",
      paragraphWhenLoggedInWithContact: (ctx) =>
        `Non hai il permesso di accedere a questa pagina. Se il tuo profilo è accettato, un admin ti darà presto i diritti per accedervi. Controlla nei prossimi 1-2 giorni lavorativi. Se non hai ancora ricevuto l'accesso allora, contattaci: ${ctx.named(
          "contactEmail"
        )}.`,
      paragraphWhenNotLoggedIn:
        "Questa pagina richiede di essere autenticati per accedervi. Clicca sul pulsante qui sotto per accedere al tuo account.",
      metaInfo: { title: "Piattaforma - 403" },
    },
    error404: {
      paragraph: "La pagina a cui stai tentando di accedere non esiste.",
      title: "404 - Pagina non trovata",
      metaInfo: { title: "Piattaforma - 404" },
    },
    unauthorizedInvestorProfile: {
      modifyInvestorProfile: "Modifica profilo investitore",
      title: "Profilo di investimento non autorizzato",
      unfortunately:
        "Sfortunatamente, non puoi accedere a questa pagina a causa del tuo profilo di investimento.",
      metaInfo: { title: "Piattaforma - Profilo Investitore Non Autorizzato" },
    },
  },
  help: {
    contact: {
      address: "Indirizzo",
      introText:
        "Non esitare a utilizzare questo modulo per metterti in contatto con noi. Saremo lieti di rispondere a qualsiasi suggerimento o rispondere a qualsiasi tipo di domanda tu possa avere relativa a questa piattaforma e ai nostri prodotti.",
      recaptchaProtect: "Questo sito è protetto da reCAPTCHA.",
      switzerland: "Svizzera",
      title: "Contatti",
      dialog: {
        confirmMessage: {
          title: "Conferma",
          text: "Vuoi inviare questo messaggio?",
        },
      },
      form: {
        country: "Paese",
        email: "Email",
        enterMessage: "Inserisci il tuo messaggio",
        exampleEmail: "mario.rossi@example.com",
        exampleName: "Mario Rossi",
        investorProfileType: "Tipo investitore",
        name: "Nome",
        sendEmail: "Invia email",
      },
      metaInfo: { title: "Piattaforma - Contatti" },
      notify: {
        errorMessage: {
          title: "Errore invio messaggio",
          text: "Spiacenti, il messaggio non ha potuto essere inviato. Riprova più tardi o contattaci direttamente via email.",
        },
        messageSent: {
          title: "Messaggio inviato",
          text: "Il messaggio è stato inviato con successo. Ti risponderemo in 1-2 giorni lavorativi.",
        },
      },
    },
    faq: {
      subtitle: "Vedi il seguente elenco per tutte le nostre domande frequenti.",
      title: "Hai delle Domande?",
      metaInfo: { title: "Piattaforma - FAQ" },
    },
    knowledgeBase: {
      investmentStrategyTechniques: "Tecniche di Strategia di Investimento",
      metaInfoTerm: (ctx) => `Knowledge Base - ${ctx.named("term")}`,
      monthlyDataBasis: "Calcolato sulla base di dati mensili.",
      noResults: "Nessun risultato trovato.",
      performanceMetrics: "Metriche di Performance",
      search: "Cerca",
      source: "Fonte",
      subtitle:
        "Trova spiegazioni sui termini tecnici generali così come su alcune delle nostre tecniche che sono visualizzate su questa piattaforma.",
      title: "Benvenuto nella nostra Knowledge Base",
      alpha: {
        title: "Alfa",
        para1:
          "{0} è utilizzato per misurare la performance superiore che una strategia o il suo gestore è in grado di generare rispetto a un benchmark. L'{1} descrive la performance al netto dell'ambiente privo di rischio e del rendimento legato al mercato (premio di mercato * {2}).",
        para2:
          'Il grafico sopra mostra un valore <span class="font-bold">alfa</span> del 4% che significa che, data la dipendenza dal mercato della strategia e l\'attuale ambiente dei tassi di interesse (rendimento privo di rischio), è stata in grado di generare un ulteriore 4% di performance rispetto a quanto ci si può aspettare.',
        para3:
          'Come indicato nel grafico sopra, la componente <span class="font-bold">alfa</span> è l\'unico driver di performance che può essere attribuito all\'abilità del gestore. Inoltre, indica che l\'<span class="font-bold">alfa</span> può diventare un numero negativo, il che significa che la performance è stata persa attraverso la gestione attiva dell\'investimento. Detto questo, una componente <span class="font-bold">alfa</span> positiva può essere vista come la componente per cui un investitore è disposto a pagare una commissione.',
        para4:
          "Più alto è l'alfa, migliore è la strategia. Un alfa alto significa che i gestori patrimoniali sono riusciti a creare valore.",
      },
      annualizedReturn: {
        title: "Rendimento annualizzato",
        para1:
          'I <span class="font-bold">rendimenti annualizzati</span> sono rendimenti cumulativi ridimensionati a un periodo di un anno. Ciò consente agli investitori di confrontare meglio i rendimenti di diversi asset che hanno posseduto per diverse durate.',
        para2:
          'Alternativamente, i <span class="font-bold">rendimenti annualizzati</span> possono anche essere interpretati come il rendimento a un anno che un investitore avrebbe guadagnato in media investendo durante un determinato periodo di tempo.',
        para3: "A parità di altre condizioni, più alto è il rendimento annualizzato, meglio è.",
      },
      annualizedVolatility: {
        title: "Volatilità annualizzata",
        para1:
          'La <span class="font-bold">volatilità annualizzata</span> è la volatilità di un investimento ridimensionata a un periodo di un anno. La <span class="font-bold" >volatilità</span> stessa misura l\'ampiezza dei movimenti di prezzo. Più tecnicamente, la <span class="font-bold" >volatilità</span> è una misura statistica della dispersione dei rendimenti (specificamente la deviazione standard dei rendimenti) in un periodo di tempo. Più alta è la <span class="font-bold" >volatilità</span>, più rischioso è l\'investimento, perché più alta è la <span class="font-bold">volatilità</span>, più è probabile che si verifichino oscillazioni maggiori.',
      },
      beta: {
        title: "Beta",
        para1:
          'Il <span class="font-bold">Beta</span> misura la dipendenza dei rendimenti. Solitamente viene utilizzato per misurare la dipendenza di un titolo o di una strategia di investimento dal rendimento del mercato. Un <span class="font-bold" >beta</span> più alto indica che il titolo si muove più aggressivamente del mercato mentre un <span class="font-bold" >beta</span> basso indica che il titolo cattura solo parzialmente i rendimenti del mercato. Il grafico sottostante mostra linee di tendenza da un investimento ad alto beta e uno a basso beta e come si sono comportati rispetto al mercato, dove la pendenza della linea di tendenza è il valore <span class="font-bold" >beta</span>. L\'investimento a basso beta mostra un <span class="font-bold">beta</span> &lt; 1 il che significa che generalmente si muove meno del mercato ma nella stessa direzione mentre l\'investimento ad alto beta mostra un <span class="font-bold" >beta</span> &gt; 1 e quindi sta generando rendimenti più estremi rispetto al mercato. Pertanto, i rendimenti nel grafico sono più ampiamente distribuiti rispetto all\'investimento a basso beta.',
        para2:
          'Sebbene si trovino raramente, esistono valori di <span class="font-bold">beta</span> negativi e indicherebbero una relazione inversa al mercato.',
        para3:
          "Quando si analizza una strategia di investimento, gli investitori cercano strategie performanti con un beta basso. Questa costellazione indica che la performance del gestore dipende meno dai rendimenti del mercato ma dall'abilità del gestore.",
      },
      calmarRatio: {
        title: "Indice di Calmar",
        para1:
          "Un rapporto utilizzato per determinare il rendimento relativo al rischio di drawdown (ribasso) in un prodotto di investimento.",
        para2: "A parità di altre condizioni, più alto è il rapporto, migliore è l'investimento.",
      },
      correlation: {
        title: "Correlazione",
        para1:
          "Il coefficiente di correlazione di Pearson (PCC) è una misura statistica che valuta la forza e la direzione di una relazione lineare tra due set di dati. È calcolato come il rapporto tra la covarianza delle due variabili e il prodotto delle loro deviazioni standard. Questa normalizzazione rende il PCC un valore compreso tra -1 e 1, dove -1 indica una correlazione lineare negativa perfetta, 1 una correlazione lineare positiva perfetta e 0 nessuna correlazione lineare. È importante notare che il PCC rileva solo relazioni lineari, non altri tipi di correlazioni.",
        para2:
          "Dati i dati accoppiati {(X,Y)} di n coppie, il PCC sarà calcolato utilizzando la seguente formula:",
      },
      cumulativeReturn: {
        title: "Rendimento cumulativo",
        para1:
          "Presentato come percentuale, il <span class=\"font-bold\">rendimento cumulativo</span> su un investimento è l'importo aggregato che l'investimento ha guadagnato o perso nel tempo.",
        para2:
          'Il <span class="font-bold">rendimento cumulativo</span> può essere facilmente dedotto da un grafico che mostra la crescita di un investimento come sopra. Utilizzando solo il primo e l\'ultimo valore del grafico, possiamo ottenere il rendimento cumulativo totale per un determinato periodo di tempo.',
      },
      informationRatio: {
        title: "Information ratio",
        para1:
          "Le strategie di investimento sono spesso misurate rispetto a un certo benchmark che consiste per lo più in uno o un mix di molti indici. Quando un gestore di investimenti batte il benchmark, è interessante per l'investitore sapere a quale costo è stato raggiunto l'obiettivo. L'<span class=\"font-bold\" >information ratio</span> è una misura che fornisce un confronto tra il rendimento in eccesso rispetto al benchmark e il tracking error che è una misura di coerenza tra la strategia e il benchmark.",
        para2:
          "L'<span class=\"font-bold\">information ratio</span> viene calcolato allo stesso modo dell'indice di Sharpe data l'assunzione che il benchmark sia uguale a un rendimento privo di rischio con una volatilità dello 0%.",
        para3:
          "A parità di altre condizioni, se questo rapporto è positivo, più è alto, più l'investimento è robusto. Un rapporto alto significa che le fluttuazioni giornaliere nei rendimenti in eccesso rispetto al benchmark sono piccole rispetto al rendimento medio in eccesso rispetto al benchmark.",
      },
      kurtosis: {
        title: "Curtosi",
        para: "La curtosi indica il picco di una distribuzione. Per la distribuzione normale, la Curtosi è 0. Più alta è la curtosi di una distribuzione, più è concentrata attorno alla sua media.",
      },
      m2RiskAdjustedPerf: {
        title: "Misura M2",
        para1:
          "La performance corretta per il rischio M2 (M-quadro), nota anche come misura M2, valuta i rendimenti corretti per il rischio di un portafoglio di investimenti. Valuta i rendimenti del portafoglio, fattorizzando il suo rischio rispetto a un benchmark, come il mercato. Essenzialmente, rappresenta la differenza nel rendimento in eccesso corretto di un portafoglio (P) rispetto al mercato, correggendo il portafoglio per corrispondere alla volatilità del mercato. Originato dall'indice di Sharpe, offre un vantaggio sostanziale esprimendo i risultati in rendimenti percentuali, a differenza dell'indice di Sharpe, che è una cifra non negativa e meno pratica per molti investitori. Questa caratteristica della misura di Modigliani la rende significativamente più facile da capire e applicare.",
        para2:
          "A parità di altre condizioni, se il rendimento dell'investimento è superiore al tasso privo di rischio, più alta è la misura M2, migliore è l'investimento. Infatti, in questo caso la misura M2 aumenta quando il rendimento della strategia aumenta, o quando la volatilità della strategia diminuisce rispetto a quella del suo benchmark.",
      },
      maximumDrawdown: {
        title: "Maximum drawdown",
        para1:
          'Un <span class="font-bold">maximum drawdown</span> è la massima perdita osservata da un picco a un minimo di un portafoglio, prima che venga raggiunto un nuovo picco. Il <span class="font-bold" >Maximum drawdown</span> è un indicatore del rischio di ribasso in un periodo di tempo specificato.',
        para2:
          'Il <span class="font-bold">Maximum drawdown</span> è un indicatore utilizzato per valutare la rischiosità relativa di una strategia rispetto a un\'altra, in quanto si concentra sulla conservazione del capitale, che è una preoccupazione chiave per la maggior parte degli investitori. Un basso maximum drawdown è preferito in quanto indica che le perdite dagli investimenti sono state piccole. Se un investimento non ha mai perso un centesimo, il <span class="font-bold" >maximum drawdown</span> sarebbe zero. Il peggior possibile <span class="font-bold">maximum drawdown</span> sarebbe 100%, il che significa che l\'investimento è completamente senza valore.',
        para3:
          "A parità di altre condizioni, più basso è il valore assoluto del maximum drawdown (cioè più vicino è il maximum drawdown allo 0%), più affidabile è l'investimento.",
        keyPoints: "Punti chiave",
        keyPoint1:
          "Il maximum drawdown è una misura del calo di prezzo più grande di un asset da un picco a un minimo.",
        keyPoint2:
          "Il maximum drawdown è considerato un indicatore di rischio di ribasso, con ampi maximum drawdown che suggeriscono che i movimenti al ribasso potrebbero essere volatili.",
        keyPoint3:
          "Mentre il maximum drawdown misura la perdita più grande, non tiene conto della frequenza delle perdite, né della dimensione di eventuali guadagni.",
      },
      metaInfo: { title: "Piattaforma - Knowledge Base" },
      omegaRatio: {
        title: "Indice Omega",
        para1:
          "L'indice Omega è una misura di performance rischio-rendimento. Calcola il rapporto ponderato per la probabilità di guadagni rispetto alle perdite.",
        para2: "A parità di altre condizioni, più alto è il rapporto, migliore è l'investimento.",
      },
      painRatio: {
        title: "Pain ratio",
        para1:
          "Come il rapporto di Calmar, il Pain ratio viene utilizzato per determinare il rendimento in eccesso rispetto al rischio di drawdown (ribasso) in un prodotto di investimento.",
        para2: "A parità di altre condizioni, più alto è il rapporto, migliore è l'investimento.",
      },
      returnVolatilityRatio: {
        title: "Rapporto rendimento/volatilità",
        para1:
          'Il <span class="font-bold">rapporto rendimento/volatilità</span> rappresenta il rendimento medio ottenuto per unità di volatilità (deviazione standard), che può essere interpretato come un\'unità di rischio. È quindi informativo su quanto bene un investitore viene compensato per il rischio assunto (più alto è il <span class="font-bold" >rapporto rendimento/volatilità</span>, più alta è la compensazione del rischio).',
        para2:
          'Tipicamente, qualsiasi <span class="font-bold">rapporto rendimento/volatilità</span> superiore a 1.0 per un periodo di tempo prolungato è considerato buono perché significa che le ricompense sono superiori al rischio assunto. Ad esempio, se la volatilità annualizzata è inferiore al rendimento annualizzato, il <span class="font-bold" >rapporto rendimento/volatilità</span> sarà superiore a 1.0.',
        para3:
          'Quindi, il <span class="font-bold">rapporto rendimento/volatilità</span> consente agli investitori di confrontare investimenti molto diversi con gli stessi criteri. Il <span class="font-bold" >rapporto rendimento/volatilità</span> consente confronti tra mele e arance.',
        keyPoints: "Punti chiave",
        keyPoint1:
          "Un alto <span class='font-bold'>rapporto rendimento/volatilità</span>  indica quanto bene un investitore viene compensato per il rischio assunto.",
        keyPoint2:
          "Il <span class='font-bold'>rapporto rendimento/volatilità</span>  adatta la performance passata di un portafoglio al rischio assunto dall'investitore e consente quindi un confronto tra investimenti molto diversi.",
      },
      sharpeRatio: {
        title: "Indice di Sharpe",
        para1:
          "L'<span class=\"font-bold\">indice di Sharpe</span> è una misura del rendimento corretto per il rischio. Confronta il rendimento in eccesso sopra un investimento privo di rischio con il rischio che è stato assunto per ottenere questo rendimento, dove il rischio per l'investitore è definito come volatilità. Il rapporto aiuta a capire il rendimento che è stato ottenuto per unità di rischio e può essere utilizzato per confrontare molteplici opportunità di investimento.",
        para2:
          "Poiché nessun investimento è totalmente privo di rischio, qualsiasi titolo con rischi minimi può essere utilizzato come proxy per i rendimenti privi di rischio. Di solito, i titoli di stato di paesi stabili si adattano bene allo scopo. Utilizziamo i tassi LIBOR a breve termine per calcolare il rendimento privo di rischio.",
        para3:
          "A parità di altre condizioni, se questo rapporto è definito (cioè se è positivo), più è alto, più l'investimento è robusto. Un rapporto alto significa che le fluttuazioni giornaliere nei rendimenti in eccesso sono piccole rispetto al rendimento medio in eccesso.",
      },
      skewness: {
        title: "Asimmetria",
        para1:
          'La frequenza di occorrenza di grandi rendimenti in una particolare direzione è misurata dall\'<span class="font-bold">asimmetria</span>. Se la frequenza di occorrenza di grandi rendimenti negativi rispetto a grandi rendimenti positivi è più alta, allora la distribuzione mostra un\'<span class="font-bold">asimmetria</span> negativa. Nel caso in cui la frequenza di grandi rendimenti positivi superi quella di grandi rendimenti negativi, allora la distribuzione mostra un\'<span class="font-bold">asimmetria</span> positiva.',
        para2:
          'Gli investitori dovrebbero guardare all\'<span class="font-bold">asimmetria</span> perché considera gli estremi dei rendimenti piuttosto che concentrarsi esclusivamente sulla media. Gli investitori a breve e medio termine in particolare devono guardare agli estremi perché è meno probabile che mantengano una strategia abbastanza a lungo per essere sicuri che la media si risolva da sola.',
      },
      sortinoRatio: {
        title: "Indice di Sortino",
        para1:
          "L'indice di Sortino è simile all'indice di Sharpe tranne per il fatto che utilizza il rischio di ribasso (volatilità al ribasso) al denominatore. Poiché la variabilità al rialzo non è necessariamente una cosa negativa, l'indice di Sortino è a volte preferibile all'indice di Sharpe.",
        para2: "A parità di altre condizioni, più alto è il rapporto, migliore è l'investimento.",
      },
      trackingError: {
        title: "Tracking error",
        para1:
          'Il <span class="font-bold">tracking error</span> è una misura del rischio di un portafoglio di investimenti dovuto alle decisioni del suo gestore di deviare dal suo benchmark. Più è alto, più il gestore è attivo nella scelta di deviare dal suo benchmark.',
        para2:
          "Matematicamente, un modo rilevante per stimarlo è calcolare la deviazione standard della differenza di rendimento tra il portafoglio e il benchmark. Quello che presentiamo su questa piattaforma è annualizzato.",
        para3:
          'È importante tenere presente che non rappresenta la rilevanza delle decisioni del gestore, ma piuttosto l\'impatto che hanno sul portafoglio finale. Così, due portafogli con performance eccellente o pessima possono avere entrambi alti <span class="font-bold">tracking error</span> rispetto al loro benchmark.',
        para4:
          "Un basso tracking error implica che un investimento non devia molto dal suo benchmark. Un alto tracking error significa che l'investimento devia molto dal suo benchmark.",
      },
      treynorRatio: {
        title: "Indice di Treynor",
        para: "Simile all'indice di Sharpe, l'indice di Treynor è una misura di efficienza che utilizza la relazione tra rendimento annualizzato corretto per il rischio e rischio. A differenza dell'indice di Sharpe, l'indice di Treynor utilizza il rischio di \"mercato\" (beta) invece del rischio totale (deviazione standard). Una buona efficienza di performance è misurata da un rapporto alto.",
      },
      valueAtRisk: {
        title: "Value-at-risk",
        para1:
          "Il VaR è una statistica che quantifica l'entità delle possibili perdite all'interno di un portafoglio in un determinato arco temporale e con una definita probabilità. VaR 1% su 1 mese = x% perdita in 1 mese con probabilità dell'1%. Più basso è, meglio è!",
        para2:
          "In pratica, è il quantile dei rendimenti della strategia corrispondente al p-value (1% o 5%).",
      },
    },
  },
  home: {
    currency: "Valuta",
    inceptionToDateReturn: "Rendimento dall'inizio",
    isin: "ISIN",
    lastChange: "Ultima modifica",
    lastDate: "Ultima data",
    lastDay: "Variazione ultimo giorno",
    lastPrice: "Ultimo prezzo",
    metaInfo: { title: (ctx) => `${ctx.named("orgName")} - Piattaforma` },
    modifyInvestorProfile: "Modifica profilo investitore",
    na: "N/D",
    noDataInTable: "Nessun prodotto da mostrare.",
    noProductsAvailable: "Nessun prodotto disponibile per il tuo ruolo e profilo investitore.",
    productName: "Nome prodotto",
    products: "Prodotti",
    search: "Cerca",
    showMoreProducts: "Mostra più prodotti",
    viewDetails: "Visualizza dettagli",
    yearToDateReturn: "Rendimento da inizio anno",
  },
  products: {
    analysis: {
      analysisPeriod: "Periodo di analisi",
      backtest: "Backtest",
      backtestOrLive: "Backtest o live",
      benchmarks: "Benchmark",
      live: "Live",
      liveProduct: (ctx) => `${ctx.named("productName")} live`,
      shareClass: "Classe di quote",
      graphs: {
        considerApproximation: "Questi valori devono essere considerati come un'approssimazione.",
        titles: {
          beta: "Beta",
          diffMonthlyReturns: "Diff. rendimenti mensili",
          drawdowns: "Drawdown",
          exposureIndices: "Esposizione agli indici",
          exposureOverTime: "Esposizione nel tempo",
          monthlyReturns: "Rendimenti mensili",
          performance: "Performance",
          relativeDrawdowns: "Drawdown relativi",
          relativePerformance: "Performance relativa",
          riskAdjustedPerformance: "Performance corretta per il rischio",
          statistics: "Statistiche",
          returnProfile: "Profilo di rendimento",
          volatility: "Volatilità",
          weightedPerformance: "Performance ponderata",
          yearlyReturns: "Rendimenti annuali",
        },
        tooltips: {
          beta: "Questo grafico mostra il beta del nostro prodotto rispetto al nostro benchmark. Per calcolarlo, utilizziamo i dati dell'ultimo anno disponibile, motivo per cui la metrica manca durante il primo anno di vita del nostro prodotto.",
          relativePerformance:
            "Questo grafico mostra un confronto della performance del nostro prodotto e della performance del nostro benchmark. Per fare ciò, i nostri rendimenti cumulativi sono divisi per i rendimenti cumulativi del nostro benchmark. Ciò significa che al 100%, entrambe le performance sono simili, altrimenti più alto è il numero, migliore è la performance del nostro prodotto rispetto al benchmark.",
          riskAdjustedPerformance:
            "Questo grafico mostra la performance corretta per il rischio. Per calcolarla, utilizziamo i dati dell'ultimo anno disponibile, motivo per cui la metrica manca durante il primo anno di vita del nostro prodotto. La performance corretta per il rischio è definita come il rapporto tra il rendimento annualizzato e la volatilità annualizzata.",
          volatility:
            "Questo grafico mostra la volatilità annualizzata (cioè deviazione standard). Per calcolarla, utilizziamo i dati dell'ultimo anno disponibile, motivo per cui la metrica manca durante il primo anno di vita del nostro prodotto.",
        },
      },
      metaInfo: { title: (ctx) => `${ctx.named("productName")} - Analisi` },
      tab: {
        historical: "Storico",
        historicalText:
          'Per i prodotti che sono già lanciati, distinguiamo la sezione "Analisi" tra "Analisi Live" e "Analisi Storica". La sezione "Analisi Storica" mira a illustrare la performance del prodotto prima del suo lancio. La performance si basa su una simulazione realistica della strategia. Tuttavia, nessun patrimonio in gestione è stato coinvolto durante il periodo di tempo corrispondente.',
        internal: "Interno",
        live: "Live",
        liveText:
          'Per i prodotti che sono già lanciati, distinguiamo la sezione "Analisi" tra "Analisi Live" e "Analisi Storica". La sezione "Analisi Live" illustra la performance dal lancio del prodotto.',
      },
    },
    documentDownload: {
      download: "Scarica",
      failure: "Il download del file è fallito, contattaci se questo è inaspettato.",
      needAuth: "Devi essere autenticato per scaricare questo documento. Accedi.",
      preparing: "Il file è in preparazione per il download...",
      success: "Il file è stato scaricato con successo.",
      tapToDownload: "Il file è pronto. Tocca il pulsante qui sotto per scaricarlo.",
      metaInfo: {
        title: (ctx) => `${ctx.named("productName")} - Download Documenti`,
      },
    },
    documents: {
      validAsOfDate: (ctx) => `Valido al: ${ctx.named("validAsOfDate")}`,
      addFile: "Aggiungi un file",
      cannotEditNameBecauseSyncedTooltip:
        "Il nome di questo documento non può essere modificato perché è sincronizzato da un'altra fonte.",
      document: "Documento",
      nameValidationError:
        "Il nome è già usato da un altro dei tuoi documenti, scegline uno diverso.",
      noDocument: "Nessun documento fornito per questo prodotto.",
      noArchivedDocument: "Nessun documento archiviato per questo prodotto.",
      noteDragAndDrop: "Nota: Trascina e rilascia le righe per riordinare i documenti.",
      shareClass: "Classe di quote",
      syncedIconTooltip: "Questo documento è sincronizzato automaticamente da un'altra fonte.",
      archiveIconTooltip: "Archivia",
      unarchiveIconTooltip: "Annulla archiviazione",
      archivedDocumentsCardTitle: "Documenti archiviati",
      dialog: {
        fileDeletion: {
          title: "Eliminazione file",
          text: "Stai per eliminare completamente il file e non potrai più accedervi. Sei sicuro?",
        },
        fileArchiving: {
          title: "Archiviazione file",
          text: 'Stai per archiviare questo file, il che significa che andrà nei tuoi "documenti archiviati" (proprio sotto i documenti). Nota che sarà possibile annullare l\'archiviazione. Vuoi archiviarlo?',
        },
        fileUnarchiving: {
          title: "Annullamento archiviazione file",
          text: "Stai per annullare l'archiviazione di questo file, il che significa che tornerà ai tuoi documenti normali. Vuoi annullare l'archiviazione?",
        },
        needLogin: {
          text: "Per scaricare questo documento, devi essere autenticato.",
          title: "Devi essere autenticato",
        },
      },
      metaInfo: { title: (ctx) => `${ctx.named("productName")} - Documenti` },
      notify: {
        savingDocumentsError:
          "Si è verificato un errore durante il tentativo di aggiornare i documenti. Riprova più tardi o contattaci.",
        savingDocumentsSuccess: "Documenti aggiornati con successo.",
        fileDownloadError: "Errore durante il download del documento, contattaci.",
      },
      prompt: {
        file: "File",
        fileDisplayName: "Nome visualizzato file",
        fileLanguage: "Lingua file",
        loginRequired: "Accesso richiesto?",
        shouldConsiderLastFactsheet:
          "Questo file deve essere considerato come l'ultimo factsheet per il prodotto?",
        validAsOfDate: "Valido al",
        addDocument: {
          title: "Aggiungi documento",
        },
        editDocumentMetadata: {
          title: "Modifica documento",
        },
        editDocumentMetadataForLang: {
          title: (ctx) => `Modifica file in ${ctx.named("lang")}`,
        },
      },
    },
    embedded: {
      perfGraph: {
        metaInfo: {
          title: (ctx) => `${ctx.named("productName")} - Grafico Performance Incorporato`,
        },
      },
      perfTable: {
        currency: "Valuta",
        inceptionDate: "Data di lancio",
        name: "Nome",
        lastPriceAsOf: "Ultimo prezzo al",
        mtd: "MTD",
        si: "SI",
        y1: "-1A",
        y3: "-3A",
        ytd: "YTD",
        metaInfo: {
          title: (ctx) => `${ctx.named("productName")} - Tabella Performance Incorporata`,
        },
      },
      statsTable: {
        feesIncluded: "Le commissioni sono incluse.",
        metaInfo: {
          title: (ctx) => `${ctx.named("productName")} - Tabella Statistiche Incorporata`,
        },
      },
    },
    events: {
      alquantUsLongShortEquityChfLive: "Alquant US Long/Short Equity Live",
      apexVolatilityLive: "Apex Volatility Live",
      covidCrisis: "Crisi COVID-19",
      crisis2022: "Crisi 2022",
      december2018Crisis: "Crisi dicembre 2018",
      erfisaEquiflexAmcLive: "Equiflex Live",
      euroCrisis: "Crisi Euro",
      hbsUsLongShortEquityLive: "Dynamic Equity Exposure Live",
      financialCrisis: "Crisi finanziaria",
      convexusLive: "Convexus Live",
      lstsLive: "LSTS Live",
      popLive: "POP Live",
      protechLive: "ProTech Live",
      sinceInception: "Dal lancio",
      ynnovationLive: "Ynnovation Live",
      alpinum: {
        bondCrash: "Crollo obbligazionario",
      },
      calmgard: {
        calmgardCovid19Crisis: "Crisi Covid 19",
        calmgardEuroCrisisOne: "Crisi Euro I",
        calmgardEuroCrisisTwo: "Crisi Euro II",
        calmgardGreekAndChinaCrisis: "Crisi Grecia & Cina",
        calmgardInterestRateSpeculationOne: "Speculazione Tassi d'Interesse I",
        calmgardInterestRateSpeculationTwo: "Speculazione Tassi d'Interesse II",
        calmgardPostFinancialCrisis: "Post Crisi Finanziaria",
        calmgardUkraineWar: "Guerra Ucraina",
      },
      falgom: {
        falgomCoronavirusPandemic: "Pandemia Coronavirus",
        falgomFedQuantitativeTapering: "Tapering Quantitativo FED",
        falgomGlobalFinancialCrisis: "Crisi Finanziaria Globale",
        falgomGrowthSlowdownChina: "Rallentamento crescita Cina",
        falgomRecessionEurope: "Recessione Europa",
        falgomVolmageddon: "Volmageddon",
      },
      sixt: {
        sixtGlobalEquityValueSinceNewModel: "Dal nuovo modello",
      },
      winvest: {
        winvestInterestRateShock: "Shock tassi d'interesse 2022-2024",
        winvestModelSimulation: "Simulazione modello",
        winvestModelSinceLaunch: "Dal lancio",
      },
    },
    report: {
      firstDateToInclude: "Prima data da includere (aaaa-mm-gg)",
      lastDateToInclude: "Ultima data da includere (aaaa-mm-gg)",
      nameValidationError:
        "Il nome è già usato da un altro dei tuoi documenti, scegline uno diverso.",
      tooManyPagesGeneratedError:
        "Sono state generate troppe pagine. Contatta il nostro team di supporto per risolvere questo problema.",
      shareClass: "Classe di quote",
      year: "Anno",
      cardTitle: {
        contacts: "Contatti",
        description: "Descrizione",
        disclaimer: "Disclaimer",
        drawdowns: "Drawdown",
        monthlyComment: "Commento mensile",
        monthlyPerformance: "Performance mensile",
        monthlyReturns: "Rendimenti mensili",
        historicalPrices: "Prezzi storici",
        productDetails: "Dettagli prodotto",
        relativePerformance: "Performance relativa",
        riskProfile: "Profilo di rischio",
        shareClasses: "Classi di quote",
        volatility: "Volatilità",
        yearlyPerformance: "Performance annuale",
      },
      dragAndDrop: {
        addGenericComponent: "Aggiungi componente generico",
        addPortfolioBreakdownOnDate:
          "Aggiungi composizione del portafoglio a una data di riferimento",
        addPortfolioBreakdownOverTime: "Aggiungi composizione del portafoglio nel tempo",
        addHoldingsTable: "Aggiungi tabella posizioni",
        availableGenericComponents: "Componenti generici",
        availableHoldingComponents: "Componenti holding",
        availableLiquidityRiskComponents: "Componenti rischio di liquidità",
        availablePerformanceRiskComponents: "Componenti rischio di performance",
        availablePredefinedComponents: "Componenti predefiniti",
        editReport: "Modifica report",
        componentTooBig:
          "Il componente è troppo grande per essere contenuto in una singola pagina.",
        saveSuccessText: "La configurazione del report è stata aggiornata con successo.",
        stopEdit: "Interrompi modifica",
        footer: {
          title: "Piè di pagina",
          page: "Pagina",
        },
        forcedElementDeletionWarning: {
          componentsWereRemoved:
            "Alcuni componenti sono stati rimossi dal tuo layout a causa delle loro dimensioni che superano l'area visualizzabile di una singola pagina o perché la colonna che li conteneva era troppo grande. Gli ID dei componenti rimossi sono:",
          resolveSolution:
            "Per risolvere questo problema, riduci l'altezza dei componenti interessati, posiziona il componente in una nuova riga singola o contattaci.",
          title: "Rimozione forzata componenti dal layout",
        },
        header: {
          title: "Intestazione",
        },
        style: {
          title: "Stile",
        },
      },
      generateReport: {
        downloadReport: "Scarica report",
        generatingReport: "Generazione report ...",
        saveReport: "Salva report nei Documenti",
        notify: {
          generatingError: "Errore durante la generazione di un report, contattaci.",
          savedInDocumentsSection: "Il tuo report è stato salvato nella sezione Documenti.",
        },
        prompt: {
          acceptText: "Salva report",
          considerLastFactsheet:
            "Questo file deve essere considerato come l'ultimo factsheet per il prodotto?",
          fileDisplayName: "Nome visualizzato file",
          loginRequired: "Accesso richiesto?",
          title: "Genera e carica report",
        },
      },
      metaInfo: { title: (ctx) => `${ctx.named("productName")} - Report` },
      shareClassesTable: {
        bloomberg: "Bloomberg",
        class: "Classe",
        currency: "Valuta",
        inception: "Lancio",
        isin: "ISIN",
        mgmtFee: "Comm. gestione",
        minInvestment: "Invest. min.",
        mtdPerf: "Perf. MTD",
        nav: "NAV",
        navDate: "Data NAV",
        perfFee: "Comm. perf.",
        siPerf: "Perf. SI",
        ter: "TER",
        ytdPerf: "Perf. YTD",
      },
      statistics: {
        title: "Statistiche",
      },
      statisticsWithPeriods: {
        title: "Performance",
        periods: {
          1: "1M",
          3: "3M",
          6: "6M",
          ytd: "YTD",
          12: "1A",
          36: "3A",
          60: "5A",
          84: "7A",
          120: "10A",
          max: "MAX",
        },
      },
    },
    months: {
      short: {
        jan: "Gen",
        feb: "Feb",
        mar: "Mar",
        apr: "Apr",
        may: "Mag",
        jun: "Giu",
        jul: "Lug",
        aug: "Ago",
        sep: "Set",
        oct: "Ott",
        nov: "Nov",
        dec: "Dic",
      },
    },
    overview: {
      aum: "AUM",
      aumDescription:
        "AUM (Assets under Management - Asset in gestione) si riferisce al valore di mercato totale delle attività gestite all'interno di questo prodotto di investimento.",
      download: "Scarica",
      keyCharacteristics: "Caratteristiche chiave",
      historicalPrices: "Prezzi storici",
      itd: "Rendimento ITD",
      itdDescription: (ctx) =>
        `ITD (inception-to-date - dall'inizio) è un periodo, che inizia dal lancio del prodotto (${ctx.named(
          "date"
        )}), e continua fino ad oggi.`,
      lastChange: "Ultima modifica",
      lastDayChange: "Variazione ultimo giorno",
      latestFactsheet: "Ultimo factsheet",
      lastWeekChange: "Variazione ultima settimana",
      lastMonthChange: "Variazione ultimo mese",
      lastQuarterChange: "Variazione ultimo trimestre",
      lastYearChange: "Variazione ultimo anno",
      monthlyReturns: "Rendimenti mensili",
      mtd: "Rendimento MTD",
      mtdDescription:
        "MTD (month-to-date - da inizio mese) è un periodo, che inizia dall'inizio del mese solare corrente, e continua fino ad oggi.",
      performance: "Performance",
      productDetails: "Dettagli prodotto",
      productTimeline: "Cronologia prodotto",
      shareClass: "Classe di quote",
      yearlyReturns: "Rendimenti annuali",
      ytd: "Rendimento YTD",
      ytdDescription:
        "YTD (year-to-date - da inizio anno) è un periodo, che inizia dall'inizio dell'anno solare corrente, e continua fino ad oggi.",
      dragAndDrop: {
        addGenericComponent: "Aggiungi componente generico",
        addPortfolioBreakdownOnDate:
          "Aggiungi composizione del portafoglio a una data di riferimento",
        addPortfolioBreakdownOverTime: "Aggiungi composizione del portafoglio nel tempo",
        addHoldingsTable: "Aggiungi tabella posizioni",
        availableGenericComponents: "Componenti generici",
        availableHoldingComponents: "Componenti holding",
        availableLiquidityRiskComponents: "Componenti rischio di liquidità",
        availablePerformanceRiskComponents: "Componenti rischio di performance",
        availablePredefinedComponents: "Componenti predefiniti",
        editOverview: "Modifica panoramica",
        saveSuccessText: "La configurazione della panoramica è stata aggiornata con successo.",
        stopEdit: "Interrompi modifica",
        style: {
          title: "Stile",
        },
      },
      follow: {
        buttonText: "Segui",
        buttonTextFollowing: "Segui già",
        notify: {
          error: "Si è verificato un errore. Riprova o contattaci se il problema persiste.",
          followSuccess: (ctx) => `Ora segui ${ctx.named("productName")}.`,
          unfollowSuccess: (ctx) => `Non segui più ${ctx.named("productName")}.`,
        },
        promptNotFollowing: {
          acceptText: "Segui",
          text: "Seguendo questo prodotto, accetti di ricevere informazioni relative al prodotto di volta in volta. Potrai sempre smettere di seguirlo per interrompere la ricezione di tali informazioni.",
          title: "Segui prodotto",
        },
        promptFollowing: {
          acceptText: "Smetti di seguire",
          text: "Attualmente segui questo prodotto. Vuoi smettere di seguirlo, il che significa che non riceverai informazioni relative al prodotto?",
          title: "Smetti di seguire prodotto",
        },
        promptNotLoggedIn: {
          cancelText: "Crea un account",
          text: "Se vuoi poter seguire questo prodotto, devi aver effettuato l'accesso al tuo account. Se non hai un account, puoi crearne uno gratuitamente.",
          title: "Segui prodotto",
        },
      },
      metaInfo: { title: (ctx) => `${ctx.named("productName")} - Panoramica` },
      statsOptions: {
        1: "1 mese",
        3: "3 mesi",
        6: "6 mesi",
        ytd: "Da inizio anno",
        12: "1 anno",
        36: "3 anni",
        60: "5 anni",
        84: "7 anni",
        120: "10 anni",
        max: "Dal lancio",
      },
    },
  },
  settings: {
    metaInfo: { title: (ctx) => `Impostazioni - ${ctx.named("name")}` },
    changePassword: {
      buttonReset: "Invia un'e-mail per reimpostare la password",
      title: "Cambia password",
      notify: {
        success: {
          title: "Email di reimpostazione inviata",
          text: (ctx) =>
            `Un'email di reimpostazione è stata inviata alla casella di posta di ${ctx.named(
              "email"
            )}. Se non appare a breve, controlla la cartella spam.`,
        },
        failure:
          "Non siamo riusciti a cambiare la tua password, contattaci utilizzando il modulo di contatto per correggere questo errore!",
      },
    },
    deleteAccount: {
      deleteYourAccount: "Elimina il tuo account",
      title: "Elimina account",
      notify: {
        success: "Il tuo account è stato eliminato con successo.",
      },
      dialog: {
        permanentlyDeleteData: {
          text: "L'eliminazione del tuo account eliminerà permanentemente tutti i tuoi dati.",
          title: "Conferma",
        },
        recentLoginNeeded: "Accesso recente necessario",
      },
    },
    editProfile: {
      company: "Azienda",
      email: "Email",
      firstName: "Nome",
      investorProfileCountry: "Paese",
      investorProfileType: "Tipo investitore",
      lastName: "Cognome",
      phone: "Telefono",
      title: "Modifica profilo",
      requiredFields:
        'I campi contrassegnati con <span class="text-danger">*</span> sono obbligatori.',
      dialog: {
        askValidation: {
          title: "Verifica dati personali",
          text: "Controlla i tuoi dati personali e salvali quando hai finito.",
        },
      },
      notify: {
        errorText:
          "Non siamo riusciti ad aggiornare i tuoi dati, contattaci utilizzando il modulo di contatto per correggere questo errore!",
        successText: "L'aggiornamento è riuscito",
      },
    },
    overview: {
      email: "Email",
      name: "Nome",
      title: "Panoramica account",
    },
  },
};
